import Vue from "vue";
import $ from "jquery";
import ToastrType from "./toastr-types.interface";
import UrlParamsRetreiver from "./url-params-retreiver";
import { playerService } from "./player-service";
import { audioService } from "./audio-service";
import Sortable from "sortablejs";
import AudioPlayer from "./components/audio-player";
import DownloadComponent from "./components/download";
import AddProjectTrackComponent from "./components/add-project-track";
import TrackDetailsComponent from "./components/track-details";
import LoadingComponent from "./components/loading";
import EditProjectComponent from "./components/edit-project";
import CreateProjectComponent from "./components/create-project";
import EmailCueSheetComponent from "./components/email-cue-sheet";
import DownloadCueSheetComponent from "./components/download-cue-sheet";
import ManageProjectsComponent from "./components/manage-projects";
import ShareProjectComponent from "./components/share-project";
import AssignToUserComponent from "./components/assign-to-user";
import SharePlaylistComponent from "./components/share-playlist";
import ShareAlbumComponent from "./components/share-album";
import ShareArtistComponent from "./components/share-artist";
import ShareLibraryComponent from "./components/share-library";
import downloadTrackCollectionComponent from "./components/download-track-collection";
import LicenseTrackComponent from "./components/license-track";
import ShareTrackComponent from "./components/share-track";
import NowPlaying from "./components/now-playing"; // Used in now-playing.blade.php
import DurationSlider from "./components/duration-slider";
import FilteringComponent from "./components/filtering";
import PlaylistsTabComponent from "./components/playlists-tab";
import PlaylistsTabCardComponent from "./components/playlists-tab-card";
import rootScoped from "./components/root-scoped";
import AlbumListResultsComponent from "./components/album-list-results";
import TypeaheadComponent from "./components/typeahead";
import SelectTypeaheadComponent from "./components/select-typeahead";
import TrackLyricsComponent from "./components/track-lyrics";
import VolumeSliderComponent from "./components/volume-slider";
import UpdateAccountPreferencesComponent from "./components/update-account-preferences"; // Used in update-account-preferences-modal.blade.php
import SubstringFilter from "./filters/substring";
import TrackUploadComponent from "./components/track-upload";
import TrackListComponent from "./components/track-list";
import VueWaypoint from "vue-waypoint";
import inViewportDirective from "vue-in-viewport-directive";
import VueLocalStorage from "vue-ls";

const VueLsOptions = {
  namespace: "beatboxplayerapp__",
};

Vue.use(VueLocalStorage, VueLsOptions);
Vue.use(VueWaypoint);
Vue.directive("in-viewport", inViewportDirective);

// The URL parser leaves "+" and "%20" encoded, so a blank search arrives as e.g. "+++".
function hasSearchQuery(parsedUrlParams) {
  const query = parsedUrlParams["search-query"];

  return typeof query === "string" && query.replace(/\+|%20/g, " ").trim() !== "";
}

// Init our PlayerApp. It begins !
window.playerApp = new Vue({
  name: "player-app",

  el: "#playerApp",

  data: {
    searchTrackResultsCount: 0,
    searchAlbumResultsCount: 0,
    searchAlbumResultsTitle: "Album Results",
    searchTrackResultsResourceUrl: "",
    searchAlbumResultsResourceUrl: "",
    searchAlbumResultsShowCount: false,
    searchTrackResultsTrackListEventId:
      window.searchTrackResultsTrackListEventId,
    searchTrackResultsAlbumListEventId:
      window.searchTrackResultsAlbumListEventId,
    currentTrackSource: [],
    fullpageLoaderVisible: false,
    fullpageLoaderText: "Loading - Please wait",
    currentTrack: null,
    favouriteAlbums: [],
    projects: [],
    quicklistProject: null,
    tracksearch: "",
    activeFilters: [],
    authenticatedUserQuicklistId: window.authenticatedUserQuicklistId,
    playerMainTabsContainerHeight: 420,
    favAlbumsCount: window.favAlbumsCount,
    searchHistory: [],
    trackHistory: [],
    playerTabsBorderColor: null,
    playerTabsBorderDefault: "#495156",
    trackListClasses: "",
    activeFilterCount: 0,
    quicklistGuestTrackCount: 0,
    sharedProjectId: false,
    sharedProjectHash: false,
    saveSharedTracks: null,
    activeSharedSaveResourceType: false,
    activeSharedSaveResourceId: false,
    adminProjectShare: null,
    isAuthenticated: window.authenticatedUserEmail !== false,
    manualCollapsed: [],
    lastPlayerActivity: null,
    audioPlayerUniqueRefreshKey: Date.now(),
    activeLibraryId: false,
    activeGenreId: false,
    idle_timer: null,
    handleTrackListRowMouseMoveDebouncer: null,
    lazyLoadedProjectTabIds: [],
    _isViewingSingleAlbum: false,
    projectTabSortAutoscrollTimer: null,
    projectTabSortAutoscrollDirection: 0,
    projectTabSortAutoscrollSpeed: 0,
    projectTabsSortable: null, // SortableJS instance for project tab drag-and-drop sorting
  },

  computed: {
    projectNavDropdownProjects() {
      return this.quicklistProject
        ? [...this.projects, this.quicklistProject]
        : this.projects;
    },

    displaySearchTrackResultsToProjectBtn() {
      return Boolean(
        this.activeSharedSaveResourceType && this.activeSharedSaveResourceId,
      );
    },
  },

  mounted() {
    this.initialiseServices();
    this.configureInitialDomState();
    this.configureAjax();
    this.setupPageLoader();
    this.idleTimeout();
    this.configureSessionDefaults();
    this.bootstrapSessionState();
    this.bootstrapWindowState();

    const vm = this;

    this.registerGlobalWindowHandlers(vm);
    this.registerCorePlayerListeners();
    this.registerSearchResultListeners();
    this.registerAudioServiceListeners();
    this.registerProjectListeners();
    this.registerQuicklistProjectUpdateListener();
    this.registerPlaylistAndDiscoveryListeners();
    this.registerResourceNavigationListeners();
    this.registerResourceFilterListeners();
    this.registerModalAndAccountListeners();
    this.registerSearchAndHistoryListeners(vm);
    this.registerKeyboardAndDomInteractionListeners(vm);
    this.registerUiAndLayoutListeners();
    this.registerContactUsModalBindings();

    this.runInitialPlayerStartup();
  },

  updated() {
    this.onWindowResize();
  },

  methods: {
    syncQuicklistTrackCount(count = null) {
      if (!this.quicklistProject) {
        return;
      }

      const resolvedCount =
        count !== null
          ? Number(count)
          : Array.isArray(window.quicklistTrackIds)
            ? window.quicklistTrackIds.length
            : 0;

      this.quicklistProject.trackcount = Number(resolvedCount || 0);
    },

    /**
     * Check if there are active filters besides album filters
     * @returns {boolean} true if there are non-album filters active
     */
    hasNonAlbumFilters() {
      if (!this.activeFilters) {
        return false;
      }

      // Check for duration filter
      if (
        this.activeFilters.durationFilter &&
        this.activeFilters.durationFilter !== false
      ) {
        return true;
      }

      // Check for search by filters
      if (
        this.activeFilters.searchByFilters &&
        this.activeFilters.searchByFilters.length > 0
      ) {
        return true;
      }

      // Check for non-album filterByFilters
      if (
        this.activeFilters.filterByFilters &&
        this.activeFilters.filterByFilters.length > 0
      ) {
        for (let filter of this.activeFilters.filterByFilters) {
          if (!filter || typeof filter.id === "undefined") {
            continue;
          }

          if (filter.id !== "album.id") {
            return true;
          }
        }
      }

      return false;
    },

    isLazyLoaded(projectId) {
      return (
        typeof this.lazyLoadedProjectTabIds[projectId] !== "undefined" &&
        this.lazyLoadedProjectTabIds[projectId] === true
      );
    },

    handleTrackListRowMouseMove(e) {
      // Initialise description tooltip
      const $fullDescriptionTooltip = window.jqueryWrapper(
        ".full-description-tooltip",
      );

      if (window.keydownCtrl === true) {
        const $trackRow = window.jqueryWrapper(e.currentTarget);
        const $firstDescCol = $trackRow.find(".col-desc").first();

        if ($firstDescCol.length) {
          const descText = $firstDescCol.text();

          $fullDescriptionTooltip.find(".inner-text").text(descText);

          $fullDescriptionTooltip.css("top", 0).css("left", 0);

          window.positionWrapper($fullDescriptionTooltip, {
            of: $trackRow,
            at: "center top",
            my: "center bottom",
            collision: "flipfit",
          });
        }

        $fullDescriptionTooltip.show();
      } else {
        window
          .jqueryWrapper(e.currentTarget)
          .find(".full-description-tooltip")
          .hide();
      }

      // Figure out if we need to remove bindings
      if (window.lastMousemovedTrackListRow !== null) {
        if (window.lastMousemovedTrackListRow !== e.currentTarget) {
          // Different to current one, unset old one if exists & create new one.
          if (
            typeof window
              .jqueryWrapper(window.lastMousemovedTrackListRow)
              .draggable("instance") !== "undefined"
          ) {
            window.dragDropWrapper(
              window.lastMousemovedTrackListRow,
              "destroy",
              "draggable",
            );
          }

          // Kill tooltips, descriptions and other BS events.
          window.webpackDestroyBsTooltipWorkaround(
            window
              .jqueryWrapper(e.currentTarget)
              .find('[data-toggle="tooltip"], .menu-dropdown .menu-icon'),
          );
          window
            .jqueryWrapper(e.currentTarget)
            .find(".menu-dropdown")
            .off("shown.bs.dropdown");
          window
            .jqueryWrapper(e.currentTarget)
            .find(".menu-dropdown")
            .off("hidden.bs.dropdown");
          window.jqueryWrapper(".full-description-tooltip").hide();
        } else {
          // Same as current one, if already exists do nothing. Otherwise create new one.
          if (
            typeof window
              .jqueryWrapper(window.lastMousemovedTrackListRow)
              .draggable("instance") !== "undefined"
          ) {
            return;
          }
        }
      }

      // Creating new drag drop.
      window.dragDropWrapper(
        e.currentTarget,
        {
          revert: "invalid",
          distance: 15,
          handle: "div,span,*",
          containment: ".player-app-container",
          zIndex: 100,
          appendTo: "body",
          cancel: ".cancel-track-draggable",
          cursorAt: {
            top: 0,
            left: 0,
          },
          helper(e) {
            const trackName = $(e.currentTarget)
              .children(".col-name")
              .find(".track-name")
              .text();

            return $(
              `<div class="track-row-draggable-helper"><div class="track-row-draggable-helper-track-title">${trackName}</div></div>`,
            );
          },
        },
        "draggable",
      );

      // Fix for hiding menu tooltip when menu down is opened/closed
      window
        .jqueryWrapper(e.currentTarget)
        .find(".menu-dropdown")
        .on("shown.bs.dropdown", () => {
          window.webpackDestroyBsTooltipWorkaround(
            window.jqueryWrapper(e.currentTarget).find(".menu-icon"),
          );
        });

      window
        .jqueryWrapper(e.currentTarget)
        .find(".menu-dropdown")
        .on("hidden.bs.dropdown", () => {
          window.webpackReinitBsTooltipWorkaround(
            window.jqueryWrapper(e.currentTarget).find(".menu-icon"),
          );
        });

      // Initialise tooltips
      window.webpackReinitBsTooltipWorkaround(
        window
          .jqueryWrapper(e.currentTarget)
          .find('[data-toggle="tooltip"], .menu-dropdown .menu-icon'),
      );

      window.lastMousemovedTrackListRow = e.currentTarget;
    },

    /**
     * Reset the audio player component completely so we don't get any leftover fluff from Howler running.
     */
    resetAudioPlayerFully() {
      this.shouldRenderAudioPlayer = false;

      Vue.nextTick(function () {
        this.shouldRenderAudioPlayer = true;
      });
    },

    /**
     * Handles what happen when a user clicks the 'Reload Player' button in the browser idle modal.
     */
    onReloadPlayerClick() {
      // True means it reloads again from the server and not your browser cache (hopefully)
      // This is handy because it can refresh the cookies and tokens that idles/logged you out in the first place.
      location.reload(true);
    },

    idleTimeout() {
      const timeoutLength = 1000 * 60 * 60 * 24;

      this.idle_timer = window.setTimeout(function () {
        window.autoreload = true;

        location.reload(true);
      }, timeoutLength);
    },

    // The user has been updated via ajax. We now expect a property on the window with all it's up to date details (ajaxUser).
    onUserUpdated() {
      this.isAuthenticated = window.authenticatedUserEmail !== false;

      this.authenticatedUserQuicklistId = window.authenticatedUserQuicklistId;

      this.registerQuicklistProjectUpdateListener();

      // Clear anything in the local storage for leftover guest quicklist.
      playerService.setLs("quicklistguest", JSON.stringify([]));

      // Check if the currently displayed library is still accessible to the logged-in user
      // If not, clear the results
      if (this.activeLibraryId && window.userLibraryIds) {
        // Convert activeLibraryId to number for comparison
        const activeLibIdNum = parseInt(this.activeLibraryId);
        const isLibraryAccessible =
          window.userLibraryIds.indexOf(activeLibIdNum) !== -1;

        if (!isLibraryAccessible) {
          // The currently displayed library is NOT accessible, clear results
          this.resetSearchTrackResults();
          this.resetSearchAlbumResults();
          this.clearSearchTerms();
          this.activeLibraryId = false;
        }
        // else: Library is still accessible, keep the albums
      }

      // Load our users projects.
      playerService.loadProjects();

      // Load fav albums on startup so counts ect are right.
      playerService.loadFavouriteAlbums();

      playerService.$emit("user-updated");

      $.ajaxSetup({
        headers: {
          "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
        cache: false,
      });
    },

    changeCurrentTrackSource: _.debounce(function (source) {
      this.currentTrackSource = source;
    }, 250),

    getProjectName(project, index) {
      let projectName = project.name;

      if (project.name.length > 30) {
        projectName = `${project.name.substring(27)}...`;
      }

      return `${index}) ${projectName}`;
    },

    openRegistrationForm() {
      setTimeout(function () {
        $(".header .register-link button").click();
      }, 300);
    },

    openLoginForm() {
      setTimeout(function () {
        $(".header .login-link button").click();
      }, 300);
    },

    closeFeatureRequiresAuthModal() {
      window.webpackCloseBsModalWorkaround("#featureRequiresAuthModal");
    },

    getLatestSearchTrackListComponent() {
      if (!Array.isArray(this.$children)) {
        return null;
      }

      return this.$children.find(
        (child) =>
          child.trackListEventId === window.searchTrackResultsTrackListEventId,
      );
    },

    async waitForLatestTrackSearchResult() {
        await this.$nextTick();

        const trackListComponent = this.getLatestSearchTrackListComponent();

        if (!trackListComponent) {
          return null;
        }

        await trackListComponent.$nextTick();

        // A newer load of the list supersedes the one awaited; follow it rather than give up.
        for (let followed = 0; followed < 5; followed++) {
          const loadPromise = trackListComponent.currentLoadPromise;

          if (!loadPromise) {
            return null;
          }

          let trackResult;

          try {
            trackResult = await loadPromise;
          } catch (error) {
            return null;
          }

          if (
            trackResult &&
            (trackResult.requestId === undefined ||
              trackResult.requestId === trackListComponent.requestId)
          ) {
            return trackResult;
          }

          if (trackListComponent.currentLoadPromise === loadPromise) {
            return null;
          }
        }

        return null;
    },

    applyAlbumSearchFromTrackResult(trackResult, flow, extraPayload = {}) {
      if (!trackResult || !Array.isArray(trackResult.albumIds)) {
        return false;
      }

      // Two waiters can follow the same load to one result; load its albums once.
      if (
        trackResult === this._appliedAlbumTrackResult &&
        this.searchAlbumResultsResourceUrl.indexOf("albumsearchfromtracks") !== -1
      ) {
        return true;
      }
      this._appliedAlbumTrackResult = trackResult;

      const albumUrl = `/albumsearchfromtracks?timestamp=${Date.now()}`;

      if (
        trackResult &&
        typeof trackResult.albumIdsCount !== "undefined" &&
        !this._isViewingSingleAlbum
      ) {
        this.searchAlbumResultsCount = trackResult.albumIdsCount || 0;
      }

      this.searchAlbumResultsResourceUrl = albumUrl;

      return true;
    },

    // Reset any URLS, Counters & collections.
    resetSearchTrackResults() {
      this.searchTrackResultsCount = 0;
      this.searchTrackResultsResourceUrl = "";
      this.trackListClasses = "";
    },

    resetSearchAlbumResults() {
      this.searchAlbumResultsCount = 0;
      this.searchAlbumResultsResourceUrl = "";
      this.searchAlbumResultsTitle = "Album Results";
      this.searchAlbumResultsShowCount = false;
      // Ensure single-album view flag is cleared so album count updates correctly
      this._isViewingSingleAlbum = false;
    },

    onClickSearchIcon: function () {
      this.clearSharedSaveResource();

      if (window.clearAlbumfilter == true) {
        // Only reset filters if there are no user-defined filters active
        if (!this.hasNonAlbumFilters()) {
          playerService.$emit("reset-filters");
        }

        window.clearAlbumfilter = false;
      }

      const $searchInput = $(".player-header-container .player-search");

      $searchInput.blur();

      this.trackListClasses = "";

      if ($searchInput.length && $searchInput.val() === "") {
        playerService.$emit("search-input-invalid");

        return;
      } else {
        playerService.$emit("search-input-valid");
      }

      window.cancelNextPerformSearch = false;

      playerService.$emit("perform-filtering-action");

      window.currentlySelectedAlbum = 0;

      const searchInputValue = $(".player-search").val();

      // Reset album count immediately so the old count doesn't flash during the debounce delay
      this.searchAlbumResultsCount = 0;
      playerService.$emit("clear-album-results");

      this.unfocusProjectTabs();

      this.performTrackSearch(searchInputValue);

      window.in_quicklist_tab = false;

      playerService.$emit("collapse-sub-tracks");

      playerService.$emit("hide-save-project-button");
    },

    clearSearchTerms() {
      window.cancelNextPerformSearch = true;

      this.tracksearch = "";
      $(".player-search").val("");
      playerService.$emit("search-query-updated", "");
    },

    onClickClearSearchTermsSilently() {
      this.tracksearch = "";
      $(".player-search").val("");
      this.resetFilters();
    },

    
    /**
     * The following methods are called from mounted, they are used to setup the initial state of the player, register event listeners and handle URL params for direct linking.
     */

    initialiseServices() {
      audioService.initialise();
    },

    configureInitialDomState() {
      //Remove our splash loader.
      $(".player-app-container").removeAttr("v-cloak");

      // Replace the intended URLS on the player page to FORCE the intended URL to stay as the Player
      // Otherwise this could of been changed from new Iframes loading on the page ect. This helps keep the
      // Auth redirect URL more appropriate.
      $('form input[name="intended"]').val("/player");

      window.manualCollapsed = [];
    },

    configureAjax() {
      // Setup any future ajax requests.
      $.ajaxSetup({
        headers: {
          "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
        cache: false,
      });
    },

    configureSessionDefaults() {
      // If track history is not initialised yet in LS. Set it early on so it's valid throughout the app.
      const trackhistoryLsCheck = playerService.getLs("trackhistory");
      if (trackhistoryLsCheck === "") {
        playerService.setLs("trackhistory", JSON.stringify([]), 60 * 60 * 24000);
      }
    },

    bootstrapSessionState() {
      // Handle the fav albums.
      if (this.isAuthenticated) {
        this.bootstrapAuthenticatedState();
      } else {
        this.bootstrapGuestState();
      }
    },

    bootstrapWindowState() {
      this.adminProjectShare = window.adminProjectShare;
    },

    bootstrapAuthenticatedState() {
      // Clear anything in the local storage for leftover guest quicklist.
      playerService.setLs("quicklistguest", JSON.stringify([]));

      // Load fav albums on startup so counts ect are right.
      playerService.loadFavouriteAlbums();
    },

    bootstrapGuestState() {
      // Load the quicklist for the guest if any.
      let quicklistGuestLS = playerService.getLs("quicklistguest");

      // Doesn't exist or is just an empty string, convert to an array.
      if (quicklistGuestLS === "") {
        quicklistGuestLS = [];
      } else {
        quicklistGuestLS = JSON.parse(quicklistGuestLS);
      }

      const quicklistTrackIds = [];

      for (let trackIndex in quicklistGuestLS) {
        if (quicklistGuestLS.hasOwnProperty(trackIndex)) {
          quicklistTrackIds.push(quicklistGuestLS[trackIndex].id);
        }
      }

      window.quicklistTrackIds = quicklistTrackIds;

      playerService.$emit("quicklist-guest-ls-updated");

      // Allow the quicklist to be dragged tracks onto.
      this.setupProjectTabDropzone("quicklist-tab-guest", "#quickList-tab");
    },

    getNewProjectTabPosition() {
      return window.authenticatedUserNewProjectTabPosition === "start"
        ? "start"
        : "end";
    },

    registerGlobalWindowHandlers(vm) {
      window.onbeforeunload = function (event) {
        event = event || window.event;

        // Clear search history.
        playerService.setLs("quicklistguest", JSON.stringify([]));

        if (
          typeof window.forceOnbeforeunloadResume !== "undefined" &&
          window.forceOnbeforeunloadResume === true
        ) {
          window.forceOnbeforeunloadResume = false; // reset
          return; // exit
        }

        if (
          window.quicklistTrackIds.length > 0 &&
          window.authenticatedUserEmail === false
        ) {
          setTimeout(function () {
            window.webpackOpenBsModalWorkaround("#saveQuicklistOnExitModal");
          }, 1);

          event.returnValue = "Are you sure you want to leave";
          return event;
        } else {
          return;
        }
      };

      window.onpopstate = function (event) {
        const url = new URL(window.location);
        const urlParams = new URLSearchParams(url.search);

        // if (url.search.startsWith("?library")) {
        //   this.onHistoryItemClick({
        //     type: "Library",
        //     id: urlParams.get("library"),
        //     name: urlParams.get("name"),
        //   });
        // }
        //
        // if (url.search.startsWith("?genre")) {
        //   this.onHistoryItemClick({
        //     type: "Genre",
        //     id: urlParams.get("genre"),
        //     name: urlParams.get("name"),
        //   });
        // }
        //
        // if (url.search.startsWith("?search")) {
        //   this.onHistoryItemClick({
        //     type: "Search",
        //     id: "",
        //     name: urlParams.get("search"),
        //   });
        // }
      }.bind(this);

      setTimeout(function () {
        if (!vm.isAuthenticated) {
          $("body").removeClass("explore-mobile-visible");
        }
      }, 500);

        // Handle receiving the event for when the user in session has been updated (probably by Ajax).
        window.jqueryEventCatcher("body", "user-updated", vm.onUserUpdated);

        $(
          "#playerHeaderButtonNewAlbums, #playerHeaderButtonFavAlbums, #playerHeaderButtonAllAlbums",
        ).click(() => {
          playerService.$emit("search-query-updated", "");
          playerService.$emit("reset-filters");
          window.clearAlbumfilter = true;
          // Switching album mode clears the single-album context so count updates correctly
          this._isViewingSingleAlbum = false;
        });
    },

    registerCorePlayerListeners() {
      // Keep quicklist guest track counter up to date.
      playerService.$on("quicklist-guest-ls-updated", () => {
        this.quicklistGuestTrackCount = window.quicklistTrackIds.length;
      });

      // Keep quicklist guest track counter up to date.
      playerService.$on("scroll-project-to-view", (projectId) => {
        this.projectScrollToView(projectId);
      });

      playerService.$on("clear-search-terms-silently", () => {
        this.onClickClearSearchTermsSilently();
      });
    },

    registerSearchResultListeners() {
      // Any track resource updates from our search track results listing we should update our totals and albums results.
      playerService.$on(
        `track-list-resource-updated-${this.searchTrackResultsTrackListEventId}`,
        (data) => {
          this.searchTrackResultsCount = data.collectionTotal;

          const ctx = this;

          setTimeout(function () {
            ctx.onWindowResize();
          }, 2500);
        },
      );

      playerService.$on(
        `album-list-resource-updated-${this.searchTrackResultsAlbumListEventId}`,
        (data) => {
          // Don't update album count if we're viewing tracks from a single album
          if (this._isViewingSingleAlbum) {
            return;
          }

          this.searchAlbumResultsCount = data.collectionTotal;
        },
      );

      // Listen for quicklist track count updates to display accurate green item count
      if (this.authenticatedUserQuicklistId) {
        playerService.$on(
          `track-list-resource-updated-${this.authenticatedUserQuicklistId}`,
          (data) => {
            this.syncQuicklistTrackCount(
              data && typeof data.collectionTotal !== "undefined"
                ? data.collectionTotal
                : 0,
            );
          },
        );
      }
    },

    registerAudioServiceListeners() {
      // When any now playing track sources update, get the data and update our player with it.
      audioService.$on("stream-track", (info) => {
        this.currentTrack = info.track;
      });
    },

    registerProjectListeners() {
      // When the projects collection gets updated, update it in our player app.
      playerService.$on("projects-updated", (projects) => {
        const ctx = this;

        // Update our projects collection efficiently
        this.projects = [];
        this.quicklistProject = null;
        let prettyNavCount = 1;

        // First pass: build projects array and find quicklist
        for (let projectIndex in projects) {
          if (projects.hasOwnProperty(projectIndex)) {
            const project = projects[projectIndex];

            project.trackcount = Number(
              typeof project.trackcount !== "undefined"
                ? project.trackcount
                : Array.isArray(project.trackids)
                  ? project.trackids.length
                  : 0,
            );

            if (
              parseInt(project.id) !== parseInt(this.authenticatedUserQuicklistId)
            ) {
              project.prettyNavId = prettyNavCount++;
              this.projects.push(project);
            } else {
              this.quicklistProject = project;
              // Check if this has a list of trackids.
              if (typeof project.trackids !== "undefined") {
                window.quicklistTrackIds = project.trackids;
              }
            }
          }
        }

        // Second pass part 1: event listeners (synchronous, fast, needed for track counts)
        for (let projectIndex in this.projects) {
          if (this.projects.hasOwnProperty(projectIndex)) {
            const project = this.projects[projectIndex];

            // Setup event listener for project track count updates (skip quicklist, already handled)
            playerService.$off(`track-list-resource-updated-${project.id}`);
            playerService.$on(
              `track-list-resource-updated-${project.id}`,
              (data) => {
                const proj = this.projects.find(
                  (p) => Number(p.id) === Number(project.id),
                );
                if (proj) {
                  proj.trackcount = Number(
                    data && typeof data.collectionTotal !== "undefined"
                      ? data.collectionTotal
                      : 0,
                  );
                }
              },
            );
          }
        }

        // Second pass part 2: droppables (lazy initialization, only needed for drag-and-drop)
        // Instead of initializing 1000+ jQuery UI droppables on page load (which
        // blocks the main thread for ~10 seconds), we lazily initialize them
        // only when the user first interacts with a track (mousedown on a track row).
        const lazyDroppableInit = () => {
          for (let projectIndex in ctx.projects) {
            if (ctx.projects.hasOwnProperty(projectIndex)) {
              const project = ctx.projects[projectIndex];

              // Setup drop zone target.
              let projectSelector = `#project${project.id}-tab`;

              ctx.setupProjectTabDropzone(project, projectSelector);
            }
          }

          if (ctx.quicklistProject) {
            ctx.setupProjectTabDropzone(ctx.quicklistProject, "#quickList-tab");
          }

          // Remove the lazy init listener so it only fires once
          $(document).off("mousedown", ".track-list-row", lazyDroppableInit);
        };

        $(document).on("mousedown", ".track-list-row", lazyDroppableInit);

        // Update project tabs widths and setup sorting once after all processing
        setTimeout(function () {
          // Update project tabs widths.
          ctx.handleTabResize();
          ctx.setupProjectTabSorting();
        }, 100);
      });

      // When the projects collection gets updated, update it in our player app.
      playerService.$on("project-saved", (savedProject) => {
        const projectIndex = this.projects.findIndex(
          (project) => parseInt(project.id) === parseInt(savedProject.id),
        );

        if (projectIndex !== -1) {
          this.$set(this.projects, projectIndex, savedProject);
        }

        this.recalculateProjectPrettyNavIds();

        if (savedProject.color) {
          this.playerTabsBorderColor = savedProject.color;
        } else {
          this.playerTabsBorderColor = this.playerTabsBorderDefault;
        }

        this.$nextTick(() => {
          this.handleTabResize();
          this.setupProjectTabSorting();
          this.projectScrollToView(savedProject.id);
        });
      });

      /**
       * Keep project changes up to date with this collection.
       */
      playerService.$on("project-updated", (updatedProject) => {
        const ctx = this;

        const newProjects = [];

        for (let projectIndex in this.projects) {
          if (this.projects.hasOwnProperty(projectIndex)) {
            let project = this.projects[projectIndex];

            if (parseInt(project.id) === parseInt(updatedProject.id)) {
              project = updatedProject;

              // Setup drop zone target.
              let projectSelector = `#project${this.projects[projectIndex].id}-tab`;

              if (
                parseInt(this.projects[projectIndex].id) ===
                parseInt(this.authenticatedUserQuicklistId)
              ) {
                projectSelector = "#quickList-tab";
              }

              this.setupProjectTabDropzone(project, projectSelector);

              // Update project tabs widths.
              setTimeout(function () {
                // Update project tabs widths.
                ctx.handleTabResize();
              }, 100);
            }

            newProjects.push(project);
          }
        }

        this.projects = [];
        this.projects = newProjects;
      });

      // When a new project gets added, also add it in our collection.
      playerService.$on("project-added", (project, sourceProjects = null) => {
        if (Array.isArray(sourceProjects)) {
          this.projects = sourceProjects.filter(
            (sourceProject) =>
              parseInt(sourceProject.id) !== parseInt(project.id) &&
              parseInt(sourceProject.id) !==
                parseInt(this.authenticatedUserQuicklistId),
          );
        }

        this.projects = this.projects.filter(
          (existingProject) =>
            parseInt(existingProject.id) !== parseInt(project.id),
        );

        if (this.getNewProjectTabPosition() === "start") {
          this.projects.unshift(project);
        } else {
          this.projects.push(project);
        }
        this.recalculateProjectPrettyNavIds();

        // projects-updated rebuilds quicklistProject from the list, so it must be included.
        playerService.$emit(
          "projects-updated",
          this.quicklistProject
            ? [...this.projects, this.quicklistProject]
            : this.projects,
        );

        this.$nextTick(() => {
          this.handleTabResize();
          this.setupProjectTabDropzone(project, `#project${project.id}-tab`);
          this.projectScrollToView(project.id);

          setTimeout(() => {
            this.persistProjectTabOrder({ refreshProjects: false });
          }, 250);
        });
      });

      // When we first load the service, pull in the projects.
      if (this.isAuthenticated) {
        playerService.loadProjects();
      }
    },

    registerQuicklistProjectUpdateListener() {
      if (window.authenticatedUserQuicklistId !== false) {
        playerService.$on(
          `project-updated-${window.authenticatedUserQuicklistId}`,
          (project) => {
            this.quicklistProject = project;

            // Check if this has a list of trackids.
            if (typeof project.trackids !== "undefined") {
              window.quicklistTrackIds = project.trackids;
            }
          },
        );
      }
    },

    registerPlaylistAndDiscoveryListeners() {
      // When we open a Playlist.
      playerService.$on("playlist-opened", (playlist) => {
        if (
          this.searchTrackResultsResourceUrl !==
          `/api/playlists/${playlist.id}/tracks`
        ) {
          this.clearSearchTerms();
          this.resetSearchTrackResults();
          this.resetSearchAlbumResults();

          this.searchAlbumResultsTitle = `${playlist.name} Playlist Results`;
          this.searchAlbumResultsShowCount = true; //

          // Update our search track results track listing to the playlist track results.
          this.searchTrackResultsResourceUrl = `/api/playlists/${playlist.id}/tracks`;
          this.searchAlbumResultsResourceUrl = `/api/playlists/${playlist.id}/albums`;
        }
        // Switch to this tab.
        window.webpackOpenBsTabWorkaround("#search-track-results-tab");

        this.playerTabsBorderColor = this.playerTabsBorderDefault;
      });

      // When we open a Playlist.
      playerService.$on("shared-playlist-opened", (playlist) => {
        this.resetSearchTrackResults();
        this.resetSearchAlbumResults();

        this.searchAlbumResultsTitle = `${playlist.name} Album Results`;
        this.searchAlbumResultsShowCount = true; //

        // Update our search track results track listing to the playlist track results.
        this.searchTrackResultsResourceUrl = `/api/playlists/${playlist.id}/tracks`;
        this.searchAlbumResultsResourceUrl = `/api/playlists/${playlist.id}/albums`;

        // Switch to this tab.
        window.webpackOpenBsTabWorkaround("#search-track-results-tab");

        this.playerTabsBorderColor = this.playerTabsBorderDefault;
      });

      playerService.$on("track-list-resource-failed", (errorMessage) => {
        playerService.toast(`Error: ${errorMessage}`, ToastrType.Error);
      });

      // When we find similar tracks
      playerService.$on("find-similar-clicked", (trackId, trackName) => {
        this.resetSearchTrackResults();
        this.resetSearchAlbumResults();

        this.searchAlbumResultsShowCount = true;

        // Update our search track results track listing to the find a like results.
        this.searchTrackResultsResourceUrl = `/api/tracks/${trackId}/find-similar`;
        this.searchAlbumResultsResourceUrl = `/api/albums/${trackId}/find-similar`;

        // Switch to this tab.
        window.webpackOpenBsTabWorkaround("#search-track-results-tab");

        this.playerTabsBorderColor = this.playerTabsBorderDefault;
        // Add a class to differentiate the first track shown in Find Similar, which will be the track searched
        this.trackListClasses = "first-row-highlighted";

        // Add the find similar search to the history
        playerService.setSearchHistory("FindAlike", trackId, trackName);
      });

      playerService.$on("find-similar-by-file-url", (url) => {
        this.resetSearchTrackResults();
        this.resetSearchAlbumResults();

        this.searchAlbumResultsShowCount = true;

        // Update our search track results track listing to the find a like results.
        this.searchAlbumResultsResourceUrl = `/api/albums/find-similar-by-file/${url}`;
        this.searchTrackResultsResourceUrl = `/api/tracks/find-similar-by-file/${url}`;

        // Switch to this tab.
        window.webpackOpenBsTabWorkaround("#search-track-results-tab");

        this.playerTabsBorderColor = this.playerTabsBorderDefault;

        // Add the file upload search to the history
        playerService.setSearchHistory("Track Upload", "", url);
      });

      // When we open a Composer.
      playerService.$on("open-composer-tracks", async (composerName) => {
        playerService.$emit("clear-filters");

        if (
          this.searchTrackResultsResourceUrl ===
          `/api/tracksearchstringbyfield/${composerName}/composer`
        ) {
          return;
        }

        const clearFiltering = true;

        this.resetSearchTrackResults();
        this.resetSearchAlbumResults();

        // Update our search track results track listing to the composer track results.
        playerService.trackResultsFromComposer(
          composerName,
          true,
          clearFiltering,
        );

        const trackResult = await this.waitForLatestTrackSearchResult();

        this.applyAlbumSearchFromTrackResult(trackResult, "open-composer-tracks");

        // Switch to this tab.
        window.webpackOpenBsTabWorkaround("#search-track-results-tab");

        this.playerTabsBorderColor = this.playerTabsBorderDefault;
      });

      playerService.$on("open-tracktitle-tracks", (tracktitle) => {
        this.resetSearchTrackResults();

        // Update our search track results track listing to the composer track results.
        this.searchTrackResultsResourceUrl = `/api/tracksearchstringbyfield/${tracktitle}/title`;

        // Switch to this tab.
        window.webpackOpenBsTabWorkaround("#search-track-results-tab");

        playerService.toast(
          `Showing Track results for Track title: ${tracktitle}`,
        );

        this.playerTabsBorderColor = this.playerTabsBorderDefault;
      });

      playerService.$on("show-track-results-for-id", (id) => {
        this.resetSearchTrackResults();

        // Update our search track results track listing to the composer track results.
        this.searchTrackResultsResourceUrl = `/api/tracksearchstringbyfield/${id}/id`;

        // Switch to this tab.
        window.webpackOpenBsTabWorkaround("#search-track-results-tab");

        this.playerTabsBorderColor = this.playerTabsBorderDefault;
      });

      playerService.$on("view-project-loaded", (project) => {
        this.resetSearchTrackResults();

        // Update our search track results track listing to the project track results.
        this.searchTrackResultsResourceUrl = `/api/projects/${project.id}/tracks`;

        // Switch to this tab.
        window.webpackOpenBsTabWorkaround("#search-track-results-tab");

        this.playerTabsBorderColor = this.playerTabsBorderDefault;
      });
    },

    registerResourceNavigationListeners() {
      // When we open an Album.
      playerService.$on("album-opened", (album) => {
        this.clearSharedSaveResource();

        // Set flag to indicate we're viewing a single album's tracks
        // This prevents album count from being reset when album list updates
        if (this.searchAlbumResultsResourceUrl !== "") {
          this._isViewingSingleAlbum = true;
        }

        this.resetSearchTrackResults();

        // Update our search track results track listing to the album track results.
        this.searchTrackResultsResourceUrl = `/api/albums/${album.id}/tracks`;

        // Switch to this tab.
        window.webpackOpenBsTabWorkaround("#search-track-results-tab");

        this.playerTabsBorderColor = this.playerTabsBorderDefault;
      });

      // When we open an Library.
      playerService.$on("library-opened", (library) => {
        this.clearSharedSaveResource();

        this.resetSearchTrackResults();

        // Navigating to a library is a full context switch — clear single-album flag
        this._isViewingSingleAlbum = false;

        this.searchAlbumResultsTitle = `${library.name} Albums`;

        // Load these albums.
        this.searchAlbumResultsResourceUrl = `/api/libraries/${library.id}/albums`;
        this.searchAlbumResultsShowCount = true;

        this.unfocusProjectTabs();
        this.unfocusMainTabs();

        // Switch to this tab.
        window.webpackOpenBsTabWorkaround("#search-album-results-tab");

        this.playerTabsBorderColor = this.playerTabsBorderDefault;
      });

      playerService.$on("default-tab-color", () => {
        this.playerTabsBorderColor = this.playerTabsBorderDefault;
      });

      // When we open an Library.
      playerService.$on("artist-opened", (artist) => {
        this.clearSharedSaveResource();

        // Todo: ... We don't need to load the entire artist anymore.

        // Reset!
        this.clearSearchTerms();
        this.resetSearchTrackResults();
        this.searchAlbumResultsTitle = `${artist.name} Albums`;

        // Load these albums.
        this.searchAlbumResultsResourceUrl = `/api/artists/${artist.id}/albums`;

        // Switch to the albums tab.
        window.webpackOpenBsTabWorkaround("#search-album-results-tab");

        this.playerTabsBorderColor = this.playerTabsBorderDefault;
      });

      playerService.$on("filtering-change", (filters) => {
        this.activeFilters = filters.filters;
        this.activeFilterCount = filters.count;

        // Do another search now the filters have changed
        // this.performTrackSearch( this.tracksearch );
      });
    },

    registerModalAndAccountListeners() {
      playerService.$on("open-delete-project-modal", (project) => {
        $("#deleteProjectModal").data("project", project);

        window.webpackOpenBsModalWorkaround("#deleteProjectModal");
      });

      playerService.$on("close-delete-project-modal", () => {
        window.webpackCloseBsModalWorkaround("#deleteProjectModal");
      });

      playerService.$on(
        "open-convert-tracklist-to-project-modal",
        (resourceType, resourceId) => {
          $("#convertTracklistToProjectModal").data(
            "resource-type",
            resourceType,
          );
          $("#convertTracklistToProjectModal").data("resource-id", resourceId);

          window.webpackOpenBsModalWorkaround("#convertTracklistToProjectModal");
        },
      );

      playerService.$on("close-convert-tracklist-to-project-modal", () => {
        window.webpackCloseBsModalWorkaround("#convertTracklistToProjectModal");

        $("#convertTracklistToProjectModal").data("resource-type", false);
        $("#convertTracklistToProjectModal").data("resource-id", false);
      });

      /**
       * Receive the event that opens the you need to be registered/logged in to access this freature modal.
       */
      playerService.$on("feature-requires-auth-modal", () => {
        window.saveGuestQuicklistAsProject = true;

        window.webpackOpenBsModalWorkaround("#featureRequiresAuthModal");
      });

      /**
       * Receive the event that opens the you need to be registered/logged in to access this feature modal. For saving quicklist
       */
      playerService.$on("save-quicklist-requires-auth-modal", () => {
        window.saveGuestQuicklistAsProject = true;

        window.webpackOpenBsModalWorkaround("#featureRequiresAuthModal");
      });

      playerService.$on("open-browser-idle-too-long-modal", () => {
        window.webpackOpenBsModalWorkaround("#browserIdleTooLongModal");
      });

      // If wanting to update Account Preferences, then we can do that within the player and update the default file type for this user in realtime.
      $(function ($) {
        $(document).on("click", ".dropdown-item-my-account", function (e) {
          e.preventDefault();

          if ($(this).hasClass("dropdown-item-update-preferences")) {
            // Updating preferences
            playerService.$emit("open-update-account-preferences", "preferences");
          } else {
            // Updating general account details.
            playerService.$emit("open-update-account-preferences", "account");
          }
        });
      });
    },

    registerSearchAndHistoryListeners(vm) {
      playerService.$on("set-tracksearch-input", (value) => {
        // Reset the search contents.
        vm.resetSearchTrackResults();
        vm.resetSearchAlbumResults();

        this.activeFilters = [];

        const existingValue = $(".player-search").val();

        if (window.keydownCtrl) {
          this.tracksearch = existingValue ? `${value} ${existingValue}` : value;
        } else {
          this.tracksearch = value;
        }

        $(".player-search").val(this.tracksearch);

        document.getElementsByClassName("input-group-addon-search")[0].click();
      });

      playerService.$on("replace-tracksearch-input", (value) => {
        this.activeFilters = [];

        this.tracksearch = value;

        $(".player-search").val(this.tracksearch);

        this.performTrackSearch(this.tracksearch);
      });

      playerService.$on("quicklist-converted-successfully", () => {
        this.closeAllProjectNavDropdown();
      });

      playerService.$on("on-search-history-click", () => {
        this.onSearchHistoryClick();
      });

      playerService.$on("on-track-history-click", () => {
        this.onTrackHistoryClick();
      });

      playerService.$on("clear-filters", () => {
        this.clearSearchTerms();
      });

      playerService.$on("hide-save-project-button", () => {
        this.saveSharedTracks = false;
        this.clearSharedSaveResource();
      });

      // After fav albums has been updated, update our count via events.
      playerService.$on("fav-albums-count-updated", (newFavAlbumsCount) => {
        this.favAlbumsCount = newFavAlbumsCount;
      });
    },

    registerUiAndLayoutListeners() {
      playerService.$on("toggle-explore-mobile-visible", () => {
        this.toggleExploreMobileVisible();

        setTimeout(() => {
          this.onWindowResize();
        }, 500);
      });

      playerService.$on("collapsed-track-info", () => {
        this.onWindowResize();
      });

      playerService.$on("download-shared-tracks", (resourceType, resourceId) => {
        this.downloadallSharedTracks(resourceType, resourceId);
      });
    },

    registerKeyboardAndDomInteractionListeners(vm) {
      /**
       * Handle clicking special keys on the keyboard that we are interested in.
       * Note: you must register theem here in instead of sub-component or they may not trigger correctly.
       */
      $(document).keyup(function (e) {
        // Check if we are currently focussed on an input as we don't want to pause and play when typing in inputs.
        const isInputFocussed = $(document.activeElement).is("input, textarea");

        if (!isInputFocussed) {
          // Handle clicking on the Spacebar
          if (e.which === 32) {
            audioService.togglePlay();

            playerService.$emit("keyboard-spacebar-pressed", e);
          }

          if (e.which === 77) {
            playerService.$emit("audio-toggle-mute");
          }

          if (e.which === 187 || e.which === 61 || e.which === 107) {
            playerService.$emit("increase-volume");
          }

          if (e.which === 189 || e.which === 173 || e.which === 109) {
            playerService.$emit("decrease-volume");
          }
        }
      });

      // Listen for the keyboard up + down events + broadcast it.
      $("body").keydown(function (event) {
        // Check if we are currently focussed on an input as we don't want to pause and play when typing in inputs.
        const isInputFocussed = $(document.activeElement).is("input, textarea");

        if (!isInputFocussed) {
          // Up + Down arrow keys to navigate track list.
          if (event.which === 38) {
            // Up
            playerService.$emit("player-app-arrow-press", "up");
          } else if (event.which === 40) {
            // Down
            playerService.$emit("player-app-arrow-press", "down");
          }

          // Left + Right arrow keys to seek within track.
          if (event.which === 37) {
            // Left
            playerService.$emit("player-app-seek-press", "backward");
          } else if (event.which === 39) {
            // Right
            playerService.$emit("player-app-seek-press", "forward");
          }
        }
      });

      window.addEventListener("resize", this.onWindowResize);

      // Handle project tab manual scrolling.
      const $playerProjectMainTabsContainer = $(
        ".playerProjectMainTabsOverflowContainer",
      );
      if ($playerProjectMainTabsContainer.length) {
        $playerProjectMainTabsContainer.scroll(function () {
          vm.projectScroll("manual");
        });
      }

      window.jqueryMousemoveWrapper(
        ".track-listing-container .track-list-row",
        function (e) {
          vm.handleTrackListRowMouseMoveDebouncer(e);
        },
      );

      this.handleTrackListRowMouseMoveDebouncer = _.debounce(function (e) {
        this.handleTrackListRowMouseMove(e);
      }, 30);

      window.lastMousemovedTrackListRow = null;
    },

    setupPageLoader() {
      // Listen for any events that we need to change our main loader properties.
      playerService.$on("loader-show", () => {
        this.fullpageLoaderVisible = true;
      });

      playerService.$on("loader-hide", () => {
        this.fullpageLoaderVisible = false;

        this.resizeTabContentContainer();
      });

      // Change the text and show it.
      playerService.$on("loader-text-show", (text) => {
        this.fullpageLoaderText = text;
        this.fullpageLoaderVisible = true;

        this.resizeTabContentContainer();
      });
    },

    registerContactUsModalBindings() {
      const $_contactUsModalNavItems = window.jqueryWrapper(
        "#viewContactUsModal .nav-item",
      );
      const $_contactUsModalNavPanes = window.jqueryWrapper(
        "#viewContactUsModal .tab-pane",
      );

      if ($_contactUsModalNavItems.length) {
        $_contactUsModalNavItems.off("click");
        $_contactUsModalNavItems.on("click", function (e) {
          e.preventDefault();

          // Open the corresponding tab pane
          const currId = e.target.id;
          const $currTabPane = window.jqueryWrapper(
            `#viewContactUsModal .tab-pane[aria-labelledby="${currId}"]`,
          );

          $_contactUsModalNavPanes.removeClass("show fade active");
          $currTabPane.addClass("active");
        });
      }
    },

    runInitialPlayerStartup() {
      // Handle tab resizes when required and initially when the player loads.
      this.projectScroll("manual");

      // This will determine our first action.
      this.checkUrlParams();

      const parsedUrlParams = UrlParamsRetreiver.get(window.location.href);

      if (
        typeof parsedUrlParams["view-shared-track"] === "undefined" &&
        typeof parsedUrlParams["view-shared-project"] === "undefined" &&
        !hasSearchQuery(parsedUrlParams)
      ) {
        // Load a random track on startup.
        playerService.loadRandomTrack(true);
      }
    },

    checkUrlParams() {
      const parsedUrlParams = UrlParamsRetreiver.get(window.location.href);

      this.clearSharedSaveResource();

      // Priority order, check if we need to do anything from the current route.
      if (typeof parsedUrlParams["view-shared-project"] !== "undefined") {
        this.sharedProjectHash = parsedUrlParams["view-shared-project"];
        this.setSharedSaveResource(
          "project",
          parsedUrlParams["view-shared-project"],
        );

        this.searchTrackResultsResourceUrl = `/api/projects/${parsedUrlParams["view-shared-project"]}/tracks`;
        window.webpackOpenBsTabWorkaround("#search-track-results-tab");
      } else if (
        typeof parsedUrlParams["view-shared-quicklist"] !== "undefined"
      ) {
        this.setSharedSaveResource(
          "project",
          parsedUrlParams["view-shared-quicklist"],
        );
        this.searchTrackResultsResourceUrl = `/api/quicklist/${parsedUrlParams["view-shared-quicklist"]}`;
        window.webpackOpenBsTabWorkaround("#search-track-results-tab");
        this.playerTabsBorderColor = this.playerTabsBorderDefault;
      } else if (typeof parsedUrlParams["view-album"] !== "undefined") {
        playerService.$emit("loader-text-show", "Loading - Album");

        setTimeout(() => {
          playerService.openAlbum(parsedUrlParams["view-album"]);

          playerService.$emit("collapse-sub-tracks");

          // Switch to this tab.
          window.webpackOpenBsTabWorkaround("#search-track-results-tab");

          // Show our player loader.
          playerService.$emit("loader-hide");
        }, 300);
      } else if (typeof parsedUrlParams["view-shared-track"] !== "undefined") {
        this.setSharedSaveResource("track", parsedUrlParams["view-shared-track"]);

        playerService.$emit("loader-text-show", "Loading - Shared Track");

        setTimeout(() => {
          this.resetSearchTrackResults();
          this.searchTrackResultsResourceUrl = `/api/tracks/collection/${parsedUrlParams["view-shared-track"]}`;
          this.searchTrackResultsCount = 1;

          playerService.streamSharedTrack(parsedUrlParams["view-shared-track"]);

          // Show our player loader.
          playerService.$emit("loader-hide");
        }, 300);
      } else if (hasSearchQuery(parsedUrlParams)) {
        playerService.$emit("loader-text-show", "Loading - Search");

        setTimeout(() => {
          let query = parsedUrlParams["search-query"];

          // If it's a URL, keep it as is. Otherwise make it more readable
          if (query.includes("http")) {
            // ensure that it's all lower case, the parsedUrlParams is converted to lowercase by default
            const parsedUrlParamsCasePreserved = UrlParamsRetreiver.get(
              window.location.href,
              false,
            );
            query = parsedUrlParamsCasePreserved["search-query"];
            query = decodeURIComponent(query);
          } else {
            query = query.split("+").join(" ");
            query = query.split("%27").join(" ");
            query = query.split("%2c").join(" ");
            query = query.split("%3f").join(" ");
            // Keep hyphens intact (e.g. "test -drums"); converting "-" to space caused double spaces and changed query meaning. BM-546
            // query = query.split("-").join(" ");
          }

          playerService.$emit("set-tracksearch-input", query);

          // Show our player loader.
          playerService.$emit("loader-hide");
        }, 300);
      } else if (
        typeof parsedUrlParams["view-playlist"] !== "undefined" ||
        typeof parsedUrlParams["playlist"] !== "undefined"
      ) {
        const playlistId =
          parsedUrlParams["view-playlist"] || parsedUrlParams["playlist"];

        if (
          typeof parsedUrlParams["view-playlist"] !== "undefined" ||
          parsedUrlParams["shared"] === "true"
        ) {
          this.setSharedSaveResource("playlist", playlistId);
        }

        if (
          typeof parsedUrlParams["playlist"] !== "undefined" &&
          typeof parsedUrlParams["view-playlist"] === "undefined"
        ) {
          const canonicalUrl = new URL(window.location.href);
          canonicalUrl.searchParams.delete("playlist");
          canonicalUrl.searchParams.set("view-playlist", playlistId);
          window.history.replaceState(null, "", canonicalUrl.toString());
        }

        playerService.$emit("loader-text-show", "Loading - Playlist");

        setTimeout(() => {
          playerService.openSharedPlaylist(playlistId);

          // Show our player loader.
          playerService.$emit("loader-hide");
        }, 300);
      } else if (typeof parsedUrlParams["view-artist"] !== "undefined") {
        playerService.$emit("loader-text-show", "Loading - Artist");

        setTimeout(() => {
          playerService.openArtist(parsedUrlParams["view-artist"]);

          // Show our player loader.
          playerService.$emit("loader-hide");
        }, 300);
      } else if (typeof parsedUrlParams["view-library"] !== "undefined") {
        playerService.$emit("loader-text-show", "Loading - Library");

        setTimeout(() => {
          playerService.openLibrary(parsedUrlParams["view-library"]);

          // Show our player loader.
          playerService.$emit("loader-hide");
        }, 300);
      } else if (typeof parsedUrlParams["view-new-albums"] !== "undefined") {
        playerService.$emit("loader-text-show", "Loading - New Albums");

        setTimeout(() => {
          this.onNewAlbumsClick();

          // Show our player loader.
          playerService.$emit("loader-hide");
        }, 300);
      } else if (typeof parsedUrlParams["view-playlists"] !== "undefined") {
        playerService.$emit("loader-text-show", "Loading - Playlists");

        setTimeout(() => {
          this.onPlaylistsTabClick();

          window.webpackOpenBsTabWorkaround("#playlists-tab");

          // Show our player loader.
          playerService.$emit("loader-hide");
        }, 300);
      } else if (typeof parsedUrlParams["view-genre"] !== "undefined") {
        playerService.$emit("loader-text-show", "Loading - Genre");

        setTimeout(() => {
          const genreName = $(
            `a[data-genre-id="${parsedUrlParams["view-genre"]}"]`,
          ).text();

          this.onGenreClick(parsedUrlParams["view-genre"], genreName);

          window.webpackOpenBsTabWorkaround("#search-track-results-tab");

          // Show our player loader.
          playerService.$emit("loader-hide");
        }, 300);
      } else {
        // Plain /player route: load the default track collection.
        this.searchTrackResultsResourceUrl = `/tracksearch?timestamp=${Date.now()}`;
        window.webpackOpenBsTabWorkaround("#search-track-results-tab");
        this.playerTabsBorderColor = this.playerTabsBorderDefault;
      }
    },

    registerResourceFilterListeners() {
        /**
       * Handle setting the "invisible fitlers". Used mostly for showing track results for a specific resource like Album or Genre, avoiding the filters.
       */
      playerService.$on("set-invisible-filters", async (filterConfig) => {
        const ctx = this;

        // Clear any existing filters. Otherwise it won't yield the expected results.
        playerService.$emit("reset-filters");

        // Reset the search contents.
        ctx.resetSearchTrackResults();
        ctx.resetSearchAlbumResults();
        ctx.searchAlbumResultsTitle = "Album Results";

        // Switch to this tab.
        window.webpackOpenBsTabWorkaround("#search-track-results-tab");

        // Reset player tabs border color.
        ctx.playerTabsBorderColor = ctx.playerTabsBorderDefault;

        if (
          typeof ctx.activeFilters === "undefined" ||
          typeof ctx.activeFilters.filterByFilters === "undefined"
        ) {
          playerService.$emit("reset-filters");
        }

        // Wait for Vue to flush reactive filter resets before applying new filter
        await ctx.$nextTick();

        // Add the filter to the list of active filters.
        ctx.activeFilters.filterByFilters.push(filterConfig);

        // Set our track-list parameters up to do the search.
        ctx.tracksearch = "";
        ctx.searchTrackResultsResourceUrl = `/tracksearch`;

        // For a single album filter (e.g. clicking the album cover in now-playing),
        if (
          filterConfig.id === "album.id" &&
          filterConfig.values &&
          filterConfig.values.length === 1
        ) {
          ctx._isViewingSingleAlbum = true;
          ctx.searchAlbumResultsCount = 1;
          ctx.searchAlbumResultsResourceUrl = `/albumsearch?timestamp=${Date.now()}`;
        } else {
          const trackResult = await ctx.waitForLatestTrackSearchResult();

          ctx.applyAlbumSearchFromTrackResult(
            trackResult,
            "set-invisible-filters",
            {
              filterId: filterConfig.id,
            },
          );
        }
      });

      /**
       * Load the Album Results tab (ONLY) from specified resource.
       */
      playerService.$on(
        "albumresults-from-resource",
        async (filterConfig, showTab) => {
          // Register a considerbale action being done on the player which delays the player being 'timed out' on the client side.
          this.determineTimedOut();

          const ctx = this;

          // Clear the single album view flag since we're loading a different resource
          this._isViewingSingleAlbum = false;

          playerService.$emit("album-list-results-reset-filter-by");

          // Clear any existing filters. Otherwise it won't yield the expected results.
          playerService.$emit("reset-filters");
          playerService.$emit("search-query-updated", "");

          // Reset the search contents.
          ctx.resetSearchAlbumResults();

          // Switch to this tab.
          if (showTab) {
            window.webpackOpenBsTabWorkaround("#search-album-results-tab");
          }

          // Reset player tabs border color.
          ctx.playerTabsBorderColor = ctx.playerTabsBorderDefault;

          // Show progress while we configure/wait for the filters to do their thing.
          playerService.$emit("loader-text-show", "Loading - Album Results");

          if (
            typeof ctx.activeFilters === "undefined" ||
            typeof ctx.activeFilters.filterByFilters === "undefined"
          ) {
            playerService.$emit("reset-filters");
          }

          // Wait for Vue to flush reactive filter/query resets before applying new filter
          await ctx.$nextTick();

          // Add the filter to the list of active filters.
          ctx.activeFilters.filterByFilters = [];
          ctx.activeFilters.filterByFilters.push(filterConfig);

          // Trigger a fresh track search first so album validation uses a real
          // server-issued session_id for the exact same filter context.
          ctx.tracksearch = "";
          ctx.searchTrackResultsResourceUrl = `/tracksearch`;

          const trackResult = await ctx.waitForLatestTrackSearchResult(
            "albumresults-from-resource",
            {
              filterId: filterConfig.id
            },
          );

          ctx.applyAlbumSearchFromTrackResult(
            trackResult,
            "albumresults-from-resource",
            {
              filterId: filterConfig.id,
            },
          );

          // When someone does a search through the player next time, we need to remember to remove the current "resource filter".
          window.nextFilterPassNeedsClearing = true;

          // Hide our player loader.
          playerService.$emit("loader-hide");
        },
      );

      /**
       * Load the Track Results tab (ONLY) from specified resource.
       */
      playerService.$on(
        "trackresults-from-resource",
        async (filterConfig, showTab) => {
          // Register a considerbale action being done on the player which delays the player being 'timed out' on the client side.
          this.determineTimedOut();

          const ctx = this;

          // If filtering by a single album, preserve the album results
          if (
            filterConfig.model === "album" &&
            filterConfig.values &&
            filterConfig.values.length === 1
          ) {
            this._isViewingSingleAlbum = true;
          }

          if (filterConfig.model !== "album") {
            playerService.$emit("album-list-results-reset-filter-by");

            if (
              this.searchAlbumResultsResourceUrl.indexOf(
                "albumsearchfromtracks",
              ) !== -1
            ) {
              playerService.$emit("search-query-updated", "");
            }
          }

          // Clear any existing filters. Otherwise it won't yield the expected results.
          if (filterConfig.clearFilters === true) {
            playerService.$emit("search-query-updated", "");
            playerService.$emit("reset-filters");
          }

          // Reset the search contents.
          ctx.resetSearchTrackResults();

          // Switch to this tab.
          if (showTab) {
            window.webpackOpenBsTabWorkaround("#search-track-results-tab");
          }

          // Reset player tabs border color.
          ctx.playerTabsBorderColor = ctx.playerTabsBorderDefault;

          // Show progress while we configure/wait for the filters to do their thing.
          playerService.$emit("loader-text-show", "Loading - Track Results");

          if (
            typeof ctx.activeFilters === "undefined" ||
            typeof ctx.activeFilters.filterByFilters === "undefined"
          ) {
            playerService.$emit("reset-filters");
          }

          // Wait for Vue to flush reactive filter/query resets before applying new filter
          await ctx.$nextTick();

          // If we are adding any new albums, lets clear the previous ones off as that functionality is no longer desired in BB (filter by multiple albums)
          if (filterConfig.id === "album.id") {
            ctx.activeFilters.filterByFilters =
              ctx.activeFilters.filterByFilters.filter((filter) => {
                return filter && filter.id !== "album.id";
              });
          }

          // Remove any existing filter with the same id to prevent duplicates
          ctx.activeFilters.filterByFilters =
            ctx.activeFilters.filterByFilters.filter(
              (filter) => filter && filter.id !== filterConfig.id,
            );

          if (
            ctx.searchAlbumResultsResourceUrl.indexOf("albumsearchfromtracks") !==
            -1
          ) {
            // Only set clearAlbumfilter if there are no other active filters besides album
            if (!ctx.hasNonAlbumFilters()) {
              window.clearAlbumfilter = true;
            }
          }

          // Remove any existing filter with the same id to prevent duplicates
          ctx.activeFilters.filterByFilters =
            ctx.activeFilters.filterByFilters.filter(
              (filter) => filter && filter.id !== filterConfig.id,
            );

          ctx.activeFilters.filterByFilters.push(filterConfig);

          // Set our track-list parameters up to do the search.
          ctx.searchTrackResultsResourceUrl = `/tracksearch`;

          // When someone does a search through the player next time, we need to remember to remove the current "resource filter".
          if (ctx.activeFilters.length < 1) {
            window.nextFilterPassNeedsClearing = true;
          }

          // Hide our player loader.
          playerService.$emit("loader-hide");
        },
      );
    },

    /********************************************************************************
     * END REGISTRATION OF LISTENERS
     ********************************************************************************/

    /**
     * Change Tab via tabId.
     *
     * @param tabId
     */
    changeTab(tabId) {
      $("#playerProjectMainTabs .nav-link").removeClass("active");

      const $tab = $(`#${tabId}`);

      if ($tab.length) {
        window.webpackOpenBsTabWorkaround($tab);

        $("#search-album-results-tab").addClass("active");
      } else {
        if (window.adminProjectShare === true) {
          playerService.toast(
            `[PLYR_291636] Error: Could not change tab: ${tabId}`,
            ToastrType.Error,
          );
        }
      }
    },

    addProject() {
      playerService.addProject();
    },

    /**
     * Opens the modal when wanting to delete a project (a prettier are you sure prompt)
     *
     * @param project
     */
    openDeleteProjectModal(project) {
      playerService.$emit("open-delete-project-modal", project);
    },

    /**
     * Removes a project instantly.
     *
     * @param project
     */
    deleteProject(project) {
      playerService.deleteProject(project);
    },

    /**
     * Removes a project instantly.
     *
     * @param project
     */
    deleteProjectSetOnDeleteModal() {
      const project = $("#deleteProjectModal").data("project");

      if (typeof project !== "undefined" && project) {
        playerService.deleteProject(project);

        $("#deleteProjectModal").data("project", false);
      }
    },

    /**
     * Converts the current track results list to a new project.
     */
    convertTrackResultsToNewProject() {
      const resourceType = $("#convertTracklistToProjectModal").data(
        "resource-type",
      );
      const resourceId = $("#convertTracklistToProjectModal").data(
        "resource-id",
      );

      switch (resourceType) {
        case "project":
          playerService.saveSharedProjectAsNewProject(resourceId, "project");
          break;

        case "track":
          playerService.saveTrackAsNewProject(resourceId);
          break;

        case "playlist":
          playerService.saveSharedProjectAsNewProject(resourceId, "playlist");
          break;
        default:
          playerService.toast(
            "[PLYR_151523] Error: Could not convert Project.",
            ToastrType.Error,
          );
          break;
      }
    },

    /**
     * Sets up the downloading of sent shared tracks.
     */
    downloadSharedTracks() {
      const resourceType = $("#convertTracklistToProjectModal").data(
        "resource-type",
      );
      const resourceId = $("#convertTracklistToProjectModal").data(
        "resource-id",
      );

      switch (resourceType) {
        case "project":
          playerService.openDownloadTrackCollection(
            "Shared Project",
            resourceId,
            "shared-project",
            false,
          );

          break;

        case "track":
          // Load Track info
          playerService.downloadTrackById(resourceId);

          break;
        default:
          playerService.toast(
            "[PLYR_151523] Error: Could not download shared tracks.",
            ToastrType.Error,
          );
          break;
      }
    },

    /**
     * Sets up the downloading of sent shared tracks.
     */
    downloadallSharedTracks(resourceType, resourceId) {
      switch (resourceType) {
        case "project":
          playerService.openDownloadTrackCollection(
            "Shared Project",
            resourceId,
            "shared-project",
            false,
          );

          break;

        case "track":
          // Load Track info
          playerService.downloadTrackById(resourceId);

          break;
        default:
          playerService.toast(
            "[PLYR_151523] Error: Could not download shared tracks.",
            ToastrType.Error,
          );
          break;
      }
    },

    /**
     * Edit the project name & description.
     *
     * @param project
     */
    editProject(project) {
      playerService.editProject(project);
    },

    /**
     * Share the project via email to  a person.
     *
     * @param project
     */
    shareProject(project) {
      playerService.shareProject(project);
    },

    assigntoUser(project) {
      playerService.assigntoUser(project);
    },

    saveasPlaylist(project) {
      $.ajax({
        method: "POST",
        url: `/api/projects/${project.id}/save-as-playlist`,
        cache: false,
      })
        .done(function (response) {
          playerService.toast(response.message, ToastrType.Success);
        })
        .fail(function (responseData) {
          playerService.toast(
            responseData.responseJSON.message,
            ToastrType.Error,
          );
        });
    },

    /**
     * Convert the Quicklist into a project.
     *
     * @param project
     */
    saveQuicklistAsProject() {
      if (window.authenticatedUserEmail === false) {
        playerService.$emit("save-quicklist-requires-auth-modal");

        return false;
      }

      return playerService.addProject(true);
    },

    /**
     * Convert the shared playlist into a project in our own list.
     */
    onClickSaveSharedTracksAsProject() {
      const parsedUrlParams = UrlParamsRetreiver.get(window.location.href);

      // Priority order, check if we need to do anything from the current route.
      if (typeof parsedUrlParams["view-shared-project"] !== "undefined") {
        playerService.saveSharedProjectAsNewProject(
          parsedUrlParams["view-shared-project"],
        );
      } else {
        playerService.toast(
          "[PLYR_151523] Error: Could not save shared Project.",
          ToastrType.Error,
        );
      }

      this.closeAllProjectNavDropdown();
    },

    dismissSaveSharedTracks() {
      this.saveSharedTracks = false;
    },

    setSharedSaveResource(resourceType = false, resourceId = false) {
      this.activeSharedSaveResourceType = resourceType;
      this.activeSharedSaveResourceId = resourceId;
    },

    clearSharedSaveResource() {
      this.setSharedSaveResource(false, false);
    },

    /**
     * Email the cuesheet to a person.
     *
     * @param project
     */
    emailCueSheet(project) {
      playerService.shareCueSheet(project);
    },

    /**
     * Download the cuesheet.
     *
     * @param project
     */
    downloadCueSheet(project) {
      playerService.openDownloadCueSheet(project);
    },

    onSearchTrackResultsTabClick() {
      this.playerTabsBorderColor = this.playerTabsBorderDefault;

      this.unfocusMainTabs();

      window.in_quicklist_tab = false;

      // Clear stale album filter flag to prevent unexpected filter clearing
      window.clearAlbumfilter = false;

      playerService.$emit("collapse-sub-tracks");

      // Always hide all loaders when clicking Track Listing tab to prevent hanging
      this.fullpageLoaderVisible = false;
      playerService.$emit("loader-hide");

      // If resource URL was already empty, the watcher won't fire, so directly emit event to track-list
      if (this.searchTrackResultsResourceUrl === "") {
        playerService.$emit(
          "force-track-list-loader-hide-" +
            this.searchTrackResultsTrackListEventId,
        );
      }
    },

    onSearchAlbumResultsTabClick() {
      this.playerTabsBorderColor = this.playerTabsBorderDefault;

      this.unfocusMainTabs();

      window.in_quicklist_tab = false;

      // Clear the single album view flag when switching to album results tab
      this._isViewingSingleAlbum = false;

      $(`.album-card-container-${window.currentlySelectedAlbum}`).addClass(
        "currently-selected",
      );

      playerService.$emit("collapse-sub-tracks");
    },

    onPlaylistClick(playlistId) {
      this.clearSharedSaveResource();

      window.cancelAlbumResultsAlterations = false;

      playerService.openPlaylist(playlistId);

      window.in_quicklist_tab = false;

      window.currentlySelectedAlbum = 0;

      playerService.$emit("collapse-sub-tracks");
    },

    /**
     * Determins when the last activities where, if they have past an hour then they have timed out, display the modal for this.
     */
    determineTimedOut() {
      window.clearTimeout(this.idle_timer);

      this.idleTimeout();

      // First activity, obvs hasn't timed out. Quit out.
      if (this.lastPlayerActivity === null) {
        this.lastPlayerActivity = new Date().getTime();
        return;
      }

      const currentTime = new Date().getTime();
      const hoursDiff =
        Math.abs(currentTime - this.lastPlayerActivity) / 3600000;

      if (hoursDiff >= 24) {
        playerService.$emit("open-browser-idle-too-long-modal");
      }

      this.lastPlayerActivity = currentTime;
    },

    onProjectTabClick(project) {
      this.clearSharedSaveResource();

      // Register a considerbale action being done on the player which delays the player being 'timed out' on the client side.
      this.determineTimedOut();

      this.lazyLoadedProjectTabIds[project.id] = true;

      // This doesn't react so we have to force it.
      this.$forceUpdate();

      window.webpackOpenBsTabWorkaround(`#project${project.id}-tab`);

      if (project.color) {
        this.playerTabsBorderColor = project.color;
      } else {
        this.playerTabsBorderColor = this.playerTabsBorderDefault;
      }

      this.unfocusMainTabs();

      if (window.authenticatedUserEmail !== false) {
        window.in_quicklist_tab = false;
      }

      playerService.$emit("collapse-sub-tracks");

      this.$nextTick(() => {
        playerService.$emit(
          `project-updated-${project.id}`,
          Object.assign({}, project, { forceUpdate: true }),
        );
      });
    },

    onAlbumClick(albumId) {
      playerService.$emit("collapse-sub-tracks");

      playerService.openAlbum(albumId);

      window.in_quicklist_tab = false;
    },

    onLibraryClick(libraryId) {
      // Clear advanced filtering
      playerService.$emit("reset-filters");

      this.activeLibraryId = libraryId;
      this.activeGenreId = false;

      this.clearSearchTerms();

      playerService.openLibrary(libraryId);

      this.toggleExploreMobileVisible();

      window.in_quicklist_tab = false;

      playerService.$emit("album-list-results-reset-filter-by");

      playerService.$emit("collapse-sub-tracks");
    },

    onArtistClick(artistId) {
      window.cancelAlbumResultsAlterations = false;

      playerService.openArtist(artistId);

      window.in_quicklist_tab = false;

      playerService.$emit("collapse-sub-tracks");
    },

    onGenreClick(genreId, genreName) {
      // const url = new URL(window.location);
      // let newUrl =
      //   url.origin + "/player?genre=" + genreId + "&name=" + genreName;
      // if (url.href !== newUrl) {
      //   console.log("window location genre is not same as last one");
      //   window.history.pushState(null, "", newUrl);
      // }

      playerService.$emit("collapse-sub-tracks");

      window.cancelAlbumResultsAlterations = false;

      this.activeLibraryId = false;
      this.activeGenreId = genreId;

      this.clearSearchTerms();

      // Reset filters and apply genre in the same tick so that when the searchFilters
      // watcher fires the URL has already been cleared to "" by resetSearchTrackResults()
      // inside the trackresults-from-resource handler. This prevents a race condition where
      // the old project-tracks AJAX (kicked off by the searchFilters watcher) could resolve
      // after the genre search and overwrite the genre results.
      playerService.$emit("reset-filters");
      playerService.trackResultsFromGenre(genreId, true);
      playerService.albumResultsFromGenre(genreId);

      // Prevent next keyword search from clearing the genre filter
      setTimeout(() => {
        window.nextFilterPassNeedsClearing = false;
      }, 1000);

      this.toggleExploreMobileVisible();

      window.in_quicklist_tab = false;

      playerService.setSearchHistory("Genre", genreId, genreName);

      playerService.$emit("album-list-results-reset-filter-by");

      playerService.$emit("collapse-sub-tracks");
    },

    onKeywordClick(keywordName) {
      playerService.$emit("collapse-sub-tracks");

      window.cancelAlbumResultsAlterations = false;

      playerService.$emit("set-tracksearch-input", keywordName);

      this.toggleExploreMobileVisible();
    },

    onHistoryItemClick(searchTerm) {
      // Clear advanced filtering
      playerService.$emit("reset-filters");

      window.cancelAlbumResultsAlterations = false;

      this.clearSearchTerms();

      if (searchTerm.type === "Search") {
        window.cancelNextPerformSearch = false;
        this.tracksearch = searchTerm.name;
        $(".player-search").val(this.tracksearch);
        this.performTrackSearch(searchTerm.name);
      }

      if (searchTerm.type === "Link") {
        playerService.$emit("set-tracksearch-input", searchTerm.name);
      }

      if (searchTerm.type === "Artist") {
        playerService.openArtist(searchTerm.id);
      }

      if (searchTerm.type === "Library") {
        this.onLibraryClick(searchTerm.id);
      }

      if (searchTerm.type === "Playlist") {
        playerService.openPlaylist(searchTerm.id);
      }

      if (searchTerm.type === "Album") {
        playerService.openAlbum(searchTerm.id);
      }

      if (searchTerm.type === "Genre") {
        playerService.trackResultsFromGenre(searchTerm.id, true);
        playerService.albumResultsFromGenre(searchTerm.id);
      }

      if (searchTerm.type === "Composer") {
        playerService.openComposerTracks(searchTerm.name);
      }

      if (searchTerm.type === "FindAlike") {
        playerService.$emit(
          "find-similar-clicked",
          searchTerm.id,
          searchTerm.name,
        );
      }

      if (searchTerm.type === "Track Upload") {
        playerService.$emit("find-similar-by-file-url", searchTerm.name);
      }

      // Loop through our search history, if the current search value exists, move it to the top.
      const searchHistory = JSON.parse(playerService.getLs("search"));
      for (let value in searchHistory) {
        if (
          JSON.stringify(searchHistory[value]) === JSON.stringify(searchTerm)
        ) {
          searchHistory.splice(value, 1);
        }
      }

      searchHistory.unshift(searchTerm);

      playerService.setLs(
        "search",
        JSON.stringify(searchHistory),
        60 * 60 * 24000,
      );

      playerService.$emit("collapse-sub-tracks");
    },

    onTrackHistoryItemClick(track) {
      audioService.stream(track);
    },

    openLibrary(libraryId) {
      window.cancelAlbumResultsAlterations = false;

      playerService.openLibrary(libraryId);

      window.in_quicklist_tab = false;

      playerService.$emit("collapse-sub-tracks");
    },

    onPlaylistsTabClick() {
      this.playerTabsBorderColor = "#b71c1c";

      this.unfocusProjectTabs();

      playerService.$emit("on-playlists-tab-click");

      window.in_quicklist_tab = false;

      playerService.$emit("collapse-sub-tracks");
    },

    onQuicklistArrowClick(dropdownId, parentId) {
      if (!window.in_quicklist_tab) {
        this.onQuicklistTabClick();
      }
      this.openProjectNavDropdown(dropdownId, parentId);
    },

    onProjectArrowClick(project, dropdownId, parentId) {
      const $projectTab = $(`#project${project.id}-tab`);
      const isProjectFocused = $projectTab.hasClass("active");

      if (!isProjectFocused) {
        this.onProjectTabClick(project);
      }

      this.openProjectNavDropdown(dropdownId, parentId);
    },

    onQuicklistTabClick() {
      this.lazyLoadedProjectTabIds[this.authenticatedUserQuicklistId] = true;

      // Force a render so the quicklist track-list component mounts before opening the tab.
      this.$forceUpdate();

      this.playerTabsBorderColor = "#4caf50";

      this.unfocusProjectTabs();

      $(function () {
        window.webpackOpenBsTabWorkaround("#quickList-tab");
      });

      if (window.authenticatedUserEmail === false) {
        playerService.$emit("quicklist-guest-ls-updated");
      } else if (
        !window.in_quicklist_tab &&
        this.authenticatedUserQuicklistId
      ) {
        playerService.$emit(
          `project-updated-${this.authenticatedUserQuicklistId}`,
          Object.assign({}, this.quicklistProject || {}, { forceUpdate: true }),
        );
      }

      // Update the quicklist count when tab is clicked
      this.syncQuicklistTrackCount();

      window.in_quicklist_tab = true;

      playerService.$emit("collapse-sub-tracks");
    },

    onArtistsTabClick() {
      this.playerTabsBorderColor = "#2196f3";

      this.unfocusProjectTabs();

      window.in_quicklist_tab = false;

      playerService.$emit("collapse-sub-tracks");
    },

    /**
     * When we resize the browser, reconfigure the tab widths.
     */
    onWindowResize() {
      this.handleTabResize();
      this.resizeTabContentContainer();
      this.projectScroll("manual");
    },

    toggleExploreMobileVisible() {
      $("body").removeClass("now-playing-mobile-visible search-mobile-visible");

      if ($("body").hasClass("explore-mobile-visible")) {
        $("body").removeClass("explore-mobile-visible");
      } else {
        $("body").addClass("explore-mobile-visible");
      }
    },

    /**
     * Keep our Quicklist project up to date.
     */
    /**
     * Resize the height of the tab content container of page height minus headers.
     */
    resizeTabContentContainer() {
      const pageHeader = $(".player-app-container > .header").outerHeight(true);
      const playerHeader = $(
        ".player-app-container .player-header-container",
      ).outerHeight(true);
      const audioPlayer = $(
        ".player-app-container .audio-player-container",
      ).outerHeight(true);
      const tabsContainer = $(
        ".player-app-container .player-tabs-container",
      ).outerHeight(true);

      const totalUsedHeight = Math.ceil(
        pageHeader + playerHeader + audioPlayer + tabsContainer,
      );
      const bodyHeight = $("body").outerHeight();

      this.playerMainTabsContainerHeight = Math.floor(
        bodyHeight - totalUsedHeight,
      );
    },

    // Resize the project tabs navigation. Usually called when updating projects or browser resize.
    handleTabResize() {
      $(function () {
        const $playerMainTabs = $("#playerMainTabs");
        const $playerProjectMainTabsContainer = $(
          ".playerProjectMainTabsOverflowContainer-parent",
        );
        const $playerProjectMainTabs = $("#playerProjectMainTabs");
        const $playerProjectScrollTabs = $("#playerProjectScrollTabs");

        if (
          $playerMainTabs.length &&
          $playerProjectMainTabs.length &&
          $playerProjectScrollTabs.length
        ) {
          const leftPadding = 8;
          const rightPadding = $playerProjectScrollTabs.outerWidth(true);
          const windowWidth = $(window).outerWidth(true);

          // Calculate the child element widths of the project tabs.
          let projectTabsWidth = 0;

          if ($playerProjectMainTabs.find(".nav-item").length) {
            $playerProjectMainTabs.find(".nav-item").each(function () {
              projectTabsWidth += $(this).outerWidth(true);
            });

            projectTabsWidth += 40;

            const calculatedPlayerProjectMainTabsWidth =
              windowWidth -
              $playerMainTabs.outerWidth(true) -
              leftPadding -
              rightPadding;

            $playerProjectMainTabsContainer.css(
              "width",
              calculatedPlayerProjectMainTabsWidth - 10,
            );
            $playerProjectMainTabs.css("width", projectTabsWidth);
          }
        }
      });
    },

    recalculateProjectPrettyNavIds() {
      let prettyNavCount = 1;

      this.projects = this.projects.map((project) => {
        if (
          project &&
          parseInt(project.id) !== parseInt(this.authenticatedUserQuicklistId)
        ) {
          project.prettyNavId = prettyNavCount++;
        }

        return project;
      });
    },

    getProjectTabOrderPayload() {
      const sorted = [];

      this.projects.forEach((project) => {
        if (
          project &&
          parseInt(project.id) !== parseInt(this.authenticatedUserQuicklistId)
        ) {
          sorted.push({
            id: project.id,
            order: sorted.length + 1,
          });
        }
      });

      return sorted;
    },

    persistProjectTabOrder(options = {}) {
      const sortedProjectIds = this.getProjectTabOrderPayload();

      if (sortedProjectIds.length) {
        playerService.instantsaveManageProjects(sortedProjectIds, options);
      }
    },

    projectTabSortAutoscrollState(pointerX, containerRect) {
      const edgeSize = 60;

      if (!containerRect || typeof pointerX !== "number") {
        return { direction: 0, speed: 0 };
      }

      let direction = 0;
      let intensity = 0;

      if (pointerX < containerRect.left + edgeSize) {
        direction = -1;
        intensity = (containerRect.left + edgeSize - pointerX) / edgeSize;
      } else if (pointerX > containerRect.right - edgeSize) {
        direction = 1;
        intensity = (pointerX - (containerRect.right - edgeSize)) / edgeSize;
      }

      if (!direction) {
        return { direction: 0, speed: 0 };
      }

      return {
        direction,
        speed: 4 + Math.round(Math.min(Math.max(intensity, 0), 1) * 20),
      };
    },

    startProjectTabSortAutoscroll(direction, speed) {
      const $playerProjectMainTabsContainer = $(
        ".playerProjectMainTabsOverflowContainer",
      );
      const $playerProjectMainTabs = $("#playerProjectMainTabs");

      if (!$playerProjectMainTabsContainer.length || !direction || !speed) {
        this.stopProjectTabSortAutoscroll();
        return;
      }

      this.projectTabSortAutoscrollDirection = direction;
      this.projectTabSortAutoscrollSpeed = speed;

      if (this.projectTabSortAutoscrollTimer) {
        return;
      }

      this.projectTabSortAutoscrollTimer = window.setInterval(() => {
        const currentScrollLeft = $playerProjectMainTabsContainer.scrollLeft();
        const maxScrollLeft = Math.max(
          $playerProjectMainTabs.outerWidth() -
            $playerProjectMainTabsContainer.outerWidth(),
          0,
        );
        const nextScrollLeft = Math.max(
          0,
          Math.min(
            currentScrollLeft +
              this.projectTabSortAutoscrollDirection *
                this.projectTabSortAutoscrollSpeed,
            maxScrollLeft,
          ),
        );

        $playerProjectMainTabsContainer.scrollLeft(nextScrollLeft);

        this.projectScroll("manual");

        if (nextScrollLeft === currentScrollLeft) {
          this.stopProjectTabSortAutoscroll();
        }
      }, 16);
    },

    stopProjectTabSortAutoscroll() {
      if (this.projectTabSortAutoscrollTimer) {
        window.clearInterval(this.projectTabSortAutoscrollTimer);
      }

      this.projectTabSortAutoscrollTimer = null;
      this.projectTabSortAutoscrollDirection = 0;
      this.projectTabSortAutoscrollSpeed = 0;
    },

    updateProjectTabSortAutoscroll(pointerX) {
      const $playerProjectMainTabsContainer = $(
        ".playerProjectMainTabsOverflowContainer",
      );
      const containerElement = $playerProjectMainTabsContainer[0];

      if (!containerElement || typeof containerElement.getBoundingClientRect !== "function") {
        this.stopProjectTabSortAutoscroll();
        return;
      }

      const autoscrollState = this.projectTabSortAutoscrollState(
        pointerX,
        containerElement.getBoundingClientRect(),
      );

      if (!autoscrollState.direction) {
        this.stopProjectTabSortAutoscroll();
        return;
      }

      this.startProjectTabSortAutoscroll(
        autoscrollState.direction,
        autoscrollState.speed,
      );
    },

    setupProjectTabSorting() {
      const ctx = this;
      const $playerProjectMainTabs = $("#playerProjectMainTabs");

      if (!$playerProjectMainTabs.length) {
        return;
      }

      // Destroy any existing SortableJS instance so we can re-create it.
      if (ctx.projectTabsSortable) {
        ctx.projectTabsSortable.destroy();
        ctx.projectTabsSortable = null;
      }

      const tabsEl = $playerProjectMainTabs[0];

      if (!tabsEl || !Sortable || !Sortable.create) {
        return;
      }

      // onMove only fires on a swap, and SortableJS stops dragover bubbling, hence capture-phase listeners.
      const onSortPointerMove = (event) =>
        ctx.updateProjectTabSortAutoscroll(event.pageX);

      // SortableJS uses delegated events rather than per-item widget
      // instances, so initialization stays fast even with 1000+ tabs.
      // Note: handle must be a valid native CSS selector (SortableJS uses
      // el.matches(), which does not support jQuery extensions like :first).
      // The main tab link is the first a.nav-link; the dropdown toggle also
      // has .nav-link, so we exclude it with :not(.dropdown-toggle).
      ctx.projectTabsSortable = Sortable.create(tabsEl, {
        animation: 150,
        draggable: "> li.project-sortable-tab",
        handle: "a.nav-link:not(.dropdown-toggle)",
        filter: ".dropdown-toggle, .dropdown-menu, #unfocus-project-tabs-tab, .trackcount",
        preventOnFilter: false,
        onStart() {
          $playerProjectMainTabs.addClass("project-tabs-sorting");
          ctx.closeAllProjectNavDropdown();
          document.addEventListener("dragover", onSortPointerMove, true);
          document.addEventListener("pointermove", onSortPointerMove, true);
        },
        onEnd(evt) {
          document.removeEventListener("dragover", onSortPointerMove, true);
          document.removeEventListener("pointermove", onSortPointerMove, true);
          ctx.stopProjectTabSortAutoscroll();
          $playerProjectMainTabs.removeClass("project-tabs-sorting");

          if (evt.oldIndex === evt.newIndex) {
            return;
          }

          const activeProjectId = $(evt.item).data("project-id");
          const orderedProjects = [];

          $playerProjectMainTabs
            .children("li.project-sortable-tab")
            .each(function () {
              const projectId = $(this).data("project-id");
              const project = ctx.getProjectById(projectId);

              if (project) {
                orderedProjects.push(project);
              }
            });

          ctx.projects.forEach((project) => {
            if (
              project &&
              parseInt(project.id) === parseInt(ctx.authenticatedUserQuicklistId)
            ) {
              orderedProjects.push(project);
            }
          });

          ctx.projects = orderedProjects;
          ctx.recalculateProjectPrettyNavIds();
          ctx.persistProjectTabOrder({
            showSuccessToast: false,
            refreshProjects: false,
          });

          ctx.$nextTick(() => {
            ctx.handleTabResize();
            ctx.projectScroll("manual");
            ctx.projectScrollToView(activeProjectId);

            ctx.projects.forEach((project) => {
              const projectSelector =
                parseInt(project.id) === parseInt(ctx.authenticatedUserQuicklistId)
                  ? "#quickList-tab"
                  : `#project${project.id}-tab`;

              ctx.setupProjectTabDropzone(project, projectSelector);
            });
          });
        },
      });
    },

    scrollToLastProject() {
      const $playerProjectMainTabsContainer = $(
        ".playerProjectMainTabsOverflowContainer",
      );
      const $playerProjectMainTabs = $("#playerProjectMainTabs");

      if (
        $playerProjectMainTabs.length &&
        $playerProjectMainTabsContainer.length
      ) {
        $playerProjectMainTabsContainer
          .stop()
          .animate({ scrollLeft: $playerProjectMainTabs.outerWidth() }, 750);
      }
    },

    // Scroll the project tabs navigation left or right.
    projectScroll(scrollDir) {
      const $playerProjectMainTabsParentContainer = $(
        ".playerProjectMainTabsOverflowContainer-parent",
      );
      const $playerProjectMainTabsContainer = $(
        ".playerProjectMainTabsOverflowContainer",
      );
      const $playerProjectMainTabs = $("#playerProjectMainTabs");

      if (
        $playerProjectMainTabs.length &&
        $playerProjectMainTabsContainer.length
      ) {
        const playerProjectTabWidth = $playerProjectMainTabs
          .find(".nav-item")
          .last()
          .outerWidth(true) || 0;
        const maxScrollLeft = Math.max(
          $playerProjectMainTabs.outerWidth() -
            $playerProjectMainTabsContainer.outerWidth(),
          0,
        );
        let offsetAlteration = 0;

        if (scrollDir === "left") {
          offsetAlteration -= playerProjectTabWidth;
        } else if (scrollDir === "right") {
          offsetAlteration += playerProjectTabWidth;
        }

        let targetScrollLeft =
          $playerProjectMainTabsContainer.scrollLeft() + offsetAlteration;

        if (scrollDir === "start") {
          targetScrollLeft = 0;
        } else if (scrollDir === "end") {
          targetScrollLeft = maxScrollLeft;
        }

        targetScrollLeft = Math.max(0, Math.min(targetScrollLeft, maxScrollLeft));

        // start left shadow
        let shadowLeftPosCalc =
          scrollDir === "manual"
            ? $playerProjectMainTabsContainer.scrollLeft()
            : targetScrollLeft;

        if (shadowLeftPosCalc >= playerProjectTabWidth / 2) {
          $playerProjectMainTabsParentContainer.addClass("show-left-shadow");
        } else {
          $playerProjectMainTabsParentContainer.removeClass("show-left-shadow");
        }

        // end left shadow

        let shadowRightPosCalc =
          scrollDir === "manual"
            ? $playerProjectMainTabsContainer.scrollLeft()
            : targetScrollLeft;

        if (
          $playerProjectMainTabs.outerWidth() -
            shadowRightPosCalc -
            $playerProjectMainTabsContainer.outerWidth() >=
          playerProjectTabWidth / 2
        ) {
          $playerProjectMainTabsParentContainer.addClass("show-right-shadow");
        } else {
          $playerProjectMainTabsParentContainer.removeClass(
            "show-right-shadow",
          );
        }

        // end right shadow

        if (scrollDir !== "manual") {
          $playerProjectMainTabsContainer.stop().animate(
            {
              scrollLeft: targetScrollLeft,
            },
            400,
          );
        }
      }
    },

    projectScrollToView(projectId) {
      const $playerProjectMainTabsContainer = $(
        ".playerProjectMainTabsOverflowContainer",
      );
      const $playerProjectMainTabs = $("#playerProjectMainTabs");
      const $playerProjectMainTabsItems = $($playerProjectMainTabs).find(
        ".nav-item",
      );

      const $selectedTab = $playerProjectMainTabs
        .find(`a[data-project-id="${projectId}"]`)
        .parent();
      const selectedTabIndex = $playerProjectMainTabsItems.index($selectedTab);

      let previousTabsWidth = 0;
      for (let i = 0; i < selectedTabIndex; i++) {
        previousTabsWidth += $($playerProjectMainTabsItems[i]).outerWidth(true);
      }

      $playerProjectMainTabsContainer
        .stop()
        .animate({ scrollLeft: previousTabsWidth }, 750);
      $($selectedTab).find("a.nav-link").first().click();
      this.onProjectTabClick(this.getProjectById(projectId));
    },

    closeProjectTabs() {
      // Hide any other open project nav dropdowns.
      this.closeAllProjectNavDropdown();
      $(".projectNavDropdownsContainer .dropdown-menu").css("display", "none");
    },

    openProjectNavDropdown(childId, parentId) {
      const ctx = this;

      // Hide any other open project nav dropdowns.
      this.closeAllProjectNavDropdown();
      $(".projectNavDropdownsContainer .dropdown-menu").css("display", "none");

      // Get current project nav dropdown elements.
      const $parentProjectNav = $(`#${parentId}`);
      const $childProjectNavDropdown = $(`#${childId}`);

      if ($parentProjectNav.length && $childProjectNavDropdown.length) {
        // Stop any scrolling on the parent project nav bar.
        $(".playerProjectMainTabsOverflowContainer").addClass("disable-scroll");

        // Turn it visible
        $childProjectNavDropdown.css("display", "block");

        // Position it relative to it's parent.
        window.positionWrapper($childProjectNavDropdown, {
          of: $parentProjectNav,
          at: "right bottom",
          my: "right top",
        });

        $(".projectNavDropdownsContainer").addClass("dropdown-is-open");

        // Setup our click handler for closing it. setTimeout it to push it to the end of the call stack so it's not called too early and prematurely closes the project tab dropdown.
        setTimeout(function () {
          $(document).on("click", ctx.projectNavDropdownClickHandler);
        }, 1);
      } else {
        console.log("Could not find child or parent project nav dropdown.");
      }
    },

    /**
     * Used to unfocus the project tabs.
     */
    unfocusProjectTabs() {
      // Change for: BB-1785
      if (
        window.in_quicklist_tab === true &&
        window.authenticatedUserEmail !== false
      ) {
        this.onQuicklistTabBlur();
      }

      window.webpackOpenBsTabWorkaround("#unfocus-project-tabs-tab");
    },

    /**
     * Used to unfocus the main tabs.
     */
    unfocusMainTabs() {
      // Change for: BB-1785
      if (
        window.in_quicklist_tab === true &&
        window.authenticatedUserEmail !== false
      ) {
        this.onQuicklistTabBlur();
      }

      window.webpackOpenBsTabWorkaround("#unfocus-main-tabs-tab");
    },

    onQuicklistTabBlur() {
      if (
        window.in_quicklist_tab === true &&
        window.authenticatedUserEmail !== false &&
        this.quicklistProject
      ) {
        const quicklistProject = Object.assign({}, this.quicklistProject, {
          forceUpdate: true,
        });

        playerService.$emit(
          `project-updated-${window.authenticatedUserQuicklistId}`,
          quicklistProject,
        );
      }
    },

    projectNavDropdownClickHandler(event) {
      const ctx = this;

      if ($(".projectNavDropdownsContainer").hasClass("dropdown-is-open")) {
        if (!$(event.target).parents(".projectNavDropdownsContainer").length) {
          ctx.closeAllProjectNavDropdown();
        }
      }
    },

    closeAllProjectNavDropdown() {
      $(".projectNavDropdownsContainer").removeClass("dropdown-is-open");

      // Hide any  open project nav dropdowns.
      $(".projectNavDropdownsContainer .dropdown-menu").css("display", "none");

      // Enable any scrolling on the parent project nav bar.
      $(".playerProjectMainTabsOverflowContainer").removeClass(
        "disable-scroll",
      );

      // Kill the click handler for closing it.
      $(document).off("click", this.projectNavDropdownClickHandler);
    },

    /**
     * Setup the 'droppable' ui widget that handles allowing 'draggable' $els onto it.
     *
     * @param project
     * @param selector
     */
    setupProjectTabDropzone(project, selector) {
      const ctx = this;

      // Re-initialise it for this selector.
      $(function () {
        window.dragDropWrapper(
          $(selector),
          {
            classes: {
              "ui-droppable-active": "ui-state-active",
              "ui-droppable-hover": "ui-state-hover",
            },
            tolerance: "pointer",
            drop(event, ui) {
              if (ui.draggable && event.target) {
                // If guest, add it to the guest quicklist.
                if (project === "quicklist-tab-guest") {
                  const trackId = $(ui.draggable).data("track-id");

                  // Get the current guest quicklist.
                  let quicklistGuestLS = playerService.getLs("quicklistguest");

                  // Doesn't exist or is just an empty string, convert to an array.
                  if (quicklistGuestLS === "") {
                    quicklistGuestLS = [];
                  } else {
                    quicklistGuestLS = JSON.parse(quicklistGuestLS);
                  }

                  if (window.quicklistTrackIds.indexOf(trackId) !== -1) {
                    playerService.toast(
                      "Track is already in your Quicklist.",
                      ToastrType.Warning,
                    );
                  } else {
                    playerService.$emit("loader-show");

                    // Remove it from the database.
                    $.ajax({
                      method: "GET",
                      url: `/api/tracks/${trackId}`,
                      cache: false,
                    })
                      .done(function (source) {
                        const subtrackless = JSON.parse(
                          JSON.stringify(source.data),
                        );
                        delete subtrackless.subtracks;

                        // Add the new track.
                        quicklistGuestLS.push(subtrackless);

                        // Stringify the lot and restore in LS.
                        playerService.setLs(
                          "quicklistguest",
                          JSON.stringify(quicklistGuestLS),
                        );

                        // Add it in the quicklist trackids too!
                        window.quicklistTrackIds.push(subtrackless.id);

                        // For any open views, highlight it.
                        $(`.track-list-row-${subtrackless.id}`)
                          .parent()
                          .addClass("in-quicklist");

                        playerService.toast(
                          "Track has been added to Quicklist.",
                        );

                        playerService.$emit("quicklist-guest-ls-updated");
                      })
                      .always(function (responseData) {
                        // Hide our player loader.
                        playerService.$emit("loader-hide");
                      });
                  }
                } else {
                  // Not guest, add it to the specific project normally.

                  const trackId = $(ui.draggable).data("track-id");
                  const projectId = $(event.target).data("project-id");

                  ctx.handleTrackDroppedOnProjectTab(trackId, projectId);
                }
              }
            },
          },
          "droppable",
        );
      });
    },

    /**
     * When a Track is dragged onto a Project Tab.
     *
     * @param trackId
     * @param projectId
     */
    handleTrackDroppedOnProjectTab(trackId, projectId) {
      if (
        typeof projectId !== "undefined" &&
        projectId !== false &&
        typeof trackId !== "undefined" &&
        trackId !== false
      ) {
        playerService.addProjectTrackByIds(projectId, trackId);
      }
    },

    /**
     * Handle what happens when we click on the manage projects button.
     */
    onManageProjectsClick() {
      playerService.openManageProjects();
    },

    /**
     * Handle what happens when we click un the unfavourite album icon.
     */
    removeFavouriteAlbum(album_id) {
      playerService.removeFavouriteAlbum(album_id);
    },

    /**
     * Handle what happens when we click on favourite album icon.
     */
    addFavouriteAlbum(album_id) {
      playerService.addFavouriteAlbum(album_id);
    },

    resetFilters() {
      // Register a considerbale action being done on the player which delays the player being 'timed out' on the client side.
      this.determineTimedOut();

      playerService.$emit("reset-filters", "resetFilters");
    },

    getProjectById(projectId) {
      return _.find(
        this.projects,
        (project) => Number(project.id) === Number(projectId),
      );
    },

    /**
     * Switch the album results over to All Albums + clear any active tabs + tracks + counts.
     */
    onAllAlbumsClick() {
      this.clearSharedSaveResource();

      window.cancelAlbumResultsAlterations = false;

      this.resetSearchTrackResults();

      playerService.$emit("album-list-results-reset-filter-by");

      this.toggleExploreMobileVisible();

      window.in_quicklist_tab = false;

      this.unfocusProjectTabs();
      this.unfocusMainTabs();

      if (this.searchAlbumResultsTitle !== "All Albums") {
        // Reset.
        window.cancelNextPerformSearch = true; // Our filter changes will attempt a research. Stop that.
        this.resetSearchAlbumResults();
      }

      // Change the visiuals of this tab to the All Albums view.
      this.searchAlbumResultsTitle = "All Albums";
      this.searchAlbumResultsShowCount = true;
      this.searchAlbumResultsResourceUrl = "/api/albums";

      this.playerTabsBorderColor = this.playerTabsBorderDefault;

      // Switch to this tab.
      window.webpackOpenBsTabWorkaround("#search-album-results-tab");

      window.cancelNextPerformSearch = false;

      playerService.$emit("collapse-sub-tracks");
    },

    onFavAlbumsClick() {
      this.clearSharedSaveResource();

      playerService.$emit("album-list-results-reset-filter-by");

      this.toggleExploreMobileVisible();

      window.in_quicklist_tab = false;

      this.unfocusProjectTabs();
      this.unfocusMainTabs();

      if (this.searchAlbumResultsTitle !== "Fave Albums") {
        // Reset.
        window.cancelNextPerformSearch = true; // Our filter changes will attempt a research. Stop that.
        this.resetSearchAlbumResults();
      }

      // Change the visiuals of this tab to the All Albums view.
      this.searchAlbumResultsTitle = "Fave Albums";
      this.searchAlbumResultsShowCount = true;
      this.searchAlbumResultsResourceUrl = "/api/favourite-albums/albums";

      this.playerTabsBorderColor = this.playerTabsBorderDefault;

      // Switch to this tab.
      window.webpackOpenBsTabWorkaround("#search-album-results-tab");

      window.cancelNextPerformSearch = false;

      playerService.$emit("collapse-sub-tracks");
    },

    /**
     * Switch the album results over to New Albums + clear any active tabs + tracks + counts.
     */
    onNewAlbumsClick() {
      this.clearSharedSaveResource();

      this.resetSearchTrackResults();
      playerService.$emit("album-list-results-reset-filter-by");

      this.toggleExploreMobileVisible();

      window.in_quicklist_tab = false;

      this.unfocusProjectTabs();
      this.unfocusMainTabs();

      this.playerTabsBorderColor = this.playerTabsBorderDefault;

      if (this.searchAlbumResultsTitle !== "New Albums") {
        // Reset.
        window.cancelNextPerformSearch = true; // Our filter changes will attempt a research. Stop that.
        this.resetSearchAlbumResults();
      }

      // Change the visiuals of this tab to the All Albums view.
      this.searchAlbumResultsTitle = "New Albums";
      this.searchAlbumResultsShowCount = true;

      this.searchAlbumResultsResourceUrl = "/api/albums-new";

      // Switch to this tab.
      window.webpackOpenBsTabWorkaround("#search-album-results-tab");

      window.cancelNextPerformSearch = false;

      playerService.$emit("collapse-sub-tracks");
    },

    onSearchHistoryClick() {
      if (playerService.getLs("search")) {
        this.searchHistory = JSON.parse(playerService.getLs("search"));
      }
    },

    onTrackHistoryClick() {
      const trackIdsCSV = JSON.parse(playerService.getLs("trackhistory"))
        .join()
        .slice(0, 99);

      if (!trackIdsCSV) {
        playerService.toast("No Played Tracks", ToastrType.Info);
      } else {
        this.resetSearchTrackResults();

        // Update our search track results track listing to the track ids string.
        this.searchTrackResultsResourceUrl = `/api/tracksfrommanyids/${trackIdsCSV}`;
        this.searchAlbumResultsResourceUrl = `/api/albumsfromtrackids/${trackIdsCSV}`;

        playerService.$emit("loading-played-tracks", trackIdsCSV.length);
        // Switch to this tab.
        window.webpackOpenBsTabWorkaround("#search-track-results-tab");

        playerService.$emit("album-list-results-reset-filter-by");

        this.playerTabsBorderColor = this.playerTabsBorderDefault;

        playerService.toast("Showing Track History (limit 100)");
      }
    },

    onClickClearSearchHistory() {
      playerService.setLs("search", "", 60 * 60 * 24000);

      this.searchHistory = [];
    },

    onClickClearTrackHistory() {
      playerService.setLs("trackhistory", JSON.stringify([]), 60 * 60 * 24000);
    },

    // Removes all the tracks in teh quicklist.
    removeQuicklistTracks() {
      playerService.removeQuicklistTracks();
    },

    onClickTrackSearchResultsDropdownToggle() {
      this.openProjectNavDropdown(
        "searchTrackResultsNavDropdownMenu",
        "searchTrackResultsNavDropdownMenuParent",
      );
    },

    onClickSearchTrackResultsConvertToProject() {
      const parsedUrlParams = UrlParamsRetreiver.get(window.location.href);
      const paramMap = {
        "view-shared-project": "project",
        "view-shared-track": "track",
        "view-shared-quicklist": "project",
        "view-playlist": "playlist",
      };

      let resourceType = false;
      let resourceId = false;

      if (this.activeSharedSaveResourceType && this.activeSharedSaveResourceId) {
        resourceType = this.activeSharedSaveResourceType;
        resourceId = this.activeSharedSaveResourceId;
      }

      for (const [param, type] of Object.entries(paramMap)) {
        if (!resourceType && parsedUrlParams[param] !== undefined) {
          resourceType = type;
          resourceId = parsedUrlParams[param];
          break;
        }
      }

      if (
        !resourceType &&
        parsedUrlParams["playlist"] !== undefined &&
        parsedUrlParams["shared"] === "true"
      ) {
        resourceType = "playlist";
        resourceId = parsedUrlParams["playlist"];
      }

      if (!resourceType || !resourceId) {
        playerService.toast(
          "[PLYR_151523] Error: Could not convert Project.",
          ToastrType.Error,
        );
        return false;
      }

      playerService.$emit(
        "open-convert-tracklist-to-project-modal",
        resourceType,
        resourceId,
      );

      return true;
    },

    /**
     * Force the track results tab to re-show even when it is already the active tab.
     * Strips Bootstrap's active/show classes from the pane then re-opens it so the
     * component's shown.bs.tab / visibility cycle runs cleanly without touching
     * any other tab (which was causing stale state to bleed into project tab views).
     */
    forceTrackResultsTabReset() {
      window.in_quicklist_tab = false;

      const $pane = $("#searchTrackResults");
      const $tab = $("#search-track-results-tab");

      // If the tab is already active Bootstrap will no-op `.tab('show')`, so we
      // manually strip the active/show classes to force a fresh activation cycle.
      if ($tab.hasClass("active")) {
        $pane.removeClass("show active");
        $tab.removeClass("active");
      }

      window.webpackOpenBsTabWorkaround("#search-track-results-tab");
    },

    performTrackSearch: _.debounce(async function (value, history = true) {
      // Register a considerbale action being done on the player which delays the player being 'timed out' on the client side.
      this.determineTimedOut();

      playerService.$emit("reset-sorting", false);

      playerService.$emit("album-list-results-reset-filter-by");

      value = value.trim().replace(/ +(?= )/g, "");

      if (window.cancelNextPerformSearch === true) {
        window.cancelNextPerformSearch = false;

        return false;
      }

      this.searchAlbumResultsTitle = "Album Results";

      // Clear the single album view flag since we're doing a fresh search
      this._isViewingSingleAlbum = false;

      // Switch to this tab (force re-init if already active).
      this.forceTrackResultsTabReset();

      // Reset player tabs border color.
      this.playerTabsBorderColor = this.playerTabsBorderDefault;

      // Set our track-list parameters up to do the search.
      this.tracksearch = value;
      const searchTimestamp = Date.now();
      this.searchTimestamp = searchTimestamp;

      // Clear both track and album results before performing the search
      playerService.$emit("clear-track-results");
      playerService.$emit("clear-album-results");
      this.searchAlbumResultsCount = 0;

      this.searchTrackResultsResourceUrl = `/tracksearch?timestamp=${searchTimestamp}`;

      if (history) {
        if (value.includes("http")) {
          playerService.setSearchHistory("Link", "", value);
        } else {
          playerService.setSearchHistory("Search", "", value);
        }
      }

      if (window.nextFilterPassNeedsClearing === true) {
        window.trackAndAlbumCancelledSteps = {
          track: false,
          album: false,
        };

        // Clear filters if required.
        playerService.$emit("reset-filters");

        window.nextFilterPassNeedsClearing = false;

        playerService.$emit("search-query-updated", value, true);
      } else {
        playerService.$emit("search-query-updated", value);
      }

      // Wait for Vue to update and track-list to create its promise
      await this.$nextTick();

      try {
        // Find the track-list component
        const trackListComponent = this.$children.find(
          (child) =>
            child.trackListEventId ===
            window.searchTrackResultsTrackListEventId,
        );

        if (trackListComponent && trackListComponent.currentLoadPromise) {
          // Wait for track search to complete
          const trackResult = await trackListComponent.currentLoadPromise;

          // A newer search started while we were waiting; ignore stale result
          if (this.searchTimestamp !== searchTimestamp) {
            return;
          }

          if (!trackResult) {
            return;
          }

          // Track search completed successfully, now trigger album search
          if (
            this.searchTrackResultsResourceUrl.indexOf("tracksearch") !== -1
          ) {
            if (
              !this.applyAlbumSearchFromTrackResult(
                trackResult,
                "performTrackSearch",
                {
                  searchValue: value,
                },
              )
            ) {
              return;
            }

            // Wait for Vue to update and album-list to create its promise
            await this.$nextTick();

            // A newer search started while we were waiting; ignore stale album trigger
            if (this.searchTimestamp !== searchTimestamp) {
              return;
            }

            // Find the album-list component
            const albumListComponent = this.$children.find(
              (child) =>
                child.albumListEventId ===
                window.searchTrackResultsAlbumListEventId,
            );

            if (albumListComponent && albumListComponent.currentLoadPromise) {
              const albumResult = await albumListComponent.currentLoadPromise;

              // ignore stale result when a newer search request is initiated
              if (this.searchTimestamp !== searchTimestamp) {
                return;
              }

              if (!albumResult) {
                return;
              }
            }
          }
        }
      } catch (error) {
        console.error("Error during track search:", error);
      }

    }, 350),

    /**
     * Download all the tracks in the Project.
     *
     * @param project
     */
    downloadProjectTrackCollection(project) {
      playerService.openDownloadTrackCollection(
        project.name,
        project.id,
        "projects",
        project.trackcount,
      );
    },
  },

  watch: {
    searchAlbumResultsResourceUrl(newValue, oldValue) {
      if (
        oldValue !== false &&
        oldValue.indexOf("libraries") !== -1 &&
        newValue.indexOf("libraries") === -1
      ) {
        this.activeLibraryId = false;
      }
    },
    searchTrackResultsResouceUrl(newValue, oldValue) {
      if (
        oldValue !== false &&
        oldValue.indexOf("genres") !== -1 &&
        newValue.indexOf("genres") === -1
      ) {
        this.activeGenreId = false;
      }
    },

    /*currentTrackSource: function (value) {

      // Force a re-render and initialisation of audioplayer.
      this.audioPlayerUniqueRefreshKey = Date.now();

    }*/
  },

  components: {
    loading: LoadingComponent,
    // Was `require("./components/track-list")`. Under webpack 5 + vue-loader 15
    // a bare require() of an ES module returns the module NAMESPACE object
    // ({ default: Ctor, __esModule: true }), not the component. Vue accepted
    // that silently as an options object with no props, so every binding on
    // <track-list> fell through to $attrs: trackListEventId was undefined, the
    // player could not find its own track-list child, and /tracksearch was
    // never sent - search, the player UI, the quicklist and downloads all
    // failed with no console error. Every sibling below already uses import.
    "track-list": TrackListComponent,
    "duration-slider": DurationSlider,
    "create-project": CreateProjectComponent,
    "edit-project": EditProjectComponent,
    "license-track": LicenseTrackComponent,
    "track-details": TrackDetailsComponent,
    "email-cue-sheet": EmailCueSheetComponent,
    "download-cue-sheet": DownloadCueSheetComponent,
    "share-project": ShareProjectComponent,
    "assign-to-user": AssignToUserComponent,
    "share-album": ShareAlbumComponent,
    "share-artist": ShareArtistComponent,
    "share-library": ShareLibraryComponent,
    "share-playlist": SharePlaylistComponent,
    "share-track": ShareTrackComponent,
    "manage-projects": ManageProjectsComponent,
    filtering: FilteringComponent,
    "album-list-results": AlbumListResultsComponent,
    "select-typeahead": SelectTypeaheadComponent,
    typeahead: TypeaheadComponent,
    "track-lyrics": TrackLyricsComponent,
    "volume-slider": VolumeSliderComponent,
    "audio-player": AudioPlayer,
    "download-track-collection": downloadTrackCollectionComponent,
    "playlists-tab": PlaylistsTabComponent,
    "playlists-tab-card": PlaylistsTabCardComponent,
    "track-upload": TrackUploadComponent,
    "project-nav-tabs": rootScoped({
      data: ["projects", "isAuthenticated", "authenticatedUserQuicklistId"],
      methods: ["onProjectTabClick", "getProjectName", "onProjectArrowClick"],
    }),
    "project-nav-dropdowns": rootScoped({
      data: [
        "projectNavDropdownProjects",
        "isAuthenticated",
        "authenticatedUserQuicklistId",
        "sharedProjectId",
        "adminProjectShare",
      ],
      methods: [
        "onClickSaveSharedTracksAsProject",
        "shareProject",
        "downloadProjectTrackCollection",
        "saveQuicklistAsProject",
        "removeQuicklistTracks",
        "emailCueSheet",
        "assigntoUser",
        "saveasPlaylist",
        "editProject",
        "openDeleteProjectModal",
      ],
    }),
  },
});
